/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Currency: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Json: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
};

export type ActiveSessionBreakdown = {
  __typename?: 'ActiveSessionBreakdown';
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type ActiveSessions = {
  __typename?: 'ActiveSessions';
  breakdown: Array<ActiveSessionBreakdown>;
  total: Scalars['Int']['output'];
};

export enum AddAuthorsErrorCode {
  AlreadyInvited = 'ALREADY_INVITED'
}

export type AddAuthorsInput = {
  fileId: Scalars['ID']['input'];
  invites: Array<InviteInput>;
};

export type AddAuthorsPayload = {
  __typename?: 'AddAuthorsPayload';
  error?: Maybe<AddCoOwnersError>;
  file?: Maybe<File>;
};

export type AddCoOwnersError = {
  __typename?: 'AddCoOwnersError';
  code: AddCoOwnersErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum AddCoOwnersErrorCode {
  AlreadyInvited = 'ALREADY_INVITED'
}

export type AddCoOwnersInput = {
  fileId: Scalars['ID']['input'];
  invites: Array<InviteInput>;
};

export type AddCoOwnersPayload = {
  __typename?: 'AddCoOwnersPayload';
  error?: Maybe<AddCoOwnersError>;
  file?: Maybe<File>;
};

export type AddCopyrightOwnerError = {
  __typename?: 'AddCopyrightOwnerError';
  code: AddCopyrightOwnerErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum AddCopyrightOwnerErrorCode {
  InvalidInput = 'INVALID_INPUT',
  LimitExceeded = 'LIMIT_EXCEEDED',
  UserNotFound = 'USER_NOT_FOUND'
}

export type AddCopyrightOwnerInput = {
  name: Scalars['String']['input'];
  type: CopyrightOwnerType;
};

export type AddCopyrightOwnerPayload = {
  __typename?: 'AddCopyrightOwnerPayload';
  copyrightOwner?: Maybe<CopyrightOwner>;
  error?: Maybe<AddCopyrightOwnerError>;
};

export type AddReportViewersError = {
  __typename?: 'AddReportViewersError';
  code: AddReportViewersErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum AddReportViewersErrorCode {
  AlreadyInvited = 'ALREADY_INVITED',
  CannotInviteSelf = 'CANNOT_INVITE_SELF',
  ReportNotCompleted = 'REPORT_NOT_COMPLETED',
  ReportNotFound = 'REPORT_NOT_FOUND'
}

export type AddReportViewersInput = {
  invites: Array<InviteInput>;
  reportId: Scalars['ID']['input'];
};

export type AddReportViewersPayload = {
  __typename?: 'AddReportViewersPayload';
  error?: Maybe<AddReportViewersError>;
  report?: Maybe<Report>;
};

export type AddTeamMemberError = {
  __typename?: 'AddTeamMemberError';
  code: AddTeamMemberErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum AddTeamMemberErrorCode {
  AlreadyAMember = 'ALREADY_A_MEMBER',
  UserNotFound = 'USER_NOT_FOUND'
}

export type AddTeamMemberInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  originId: Scalars['ID']['input'];
  permissions?: InputMaybe<Array<TeamPermission>>;
  role: TeamRole;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddTeamMemberPayload = {
  __typename?: 'AddTeamMemberPayload';
  error?: Maybe<AddTeamMemberError>;
  member?: Maybe<TeamMember>;
};

export enum AddViewersErrorCode {
  AlreadyInvited = 'ALREADY_INVITED'
}

export type AddViewersInput = {
  fileId: Scalars['ID']['input'];
  invites: Array<InviteInput>;
};

export type AddViewersPayload = {
  __typename?: 'AddViewersPayload';
  error?: Maybe<AddCoOwnersError>;
  file?: Maybe<File>;
};

export type AdjustOverdueInvoiceError = {
  __typename?: 'AdjustOverdueInvoiceError';
  code: AdjustOverdueInvoiceErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum AdjustOverdueInvoiceErrorCode {
  InvalidStatus = 'INVALID_STATUS',
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR'
}

export type AdjustOverdueInvoiceInput = {
  discountAmount?: InputMaybe<Scalars['Int']['input']>;
  discountDescription?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
};

export type AdjustOverdueInvoicePayload = {
  __typename?: 'AdjustOverdueInvoicePayload';
  error?: Maybe<AdjustOverdueInvoiceError>;
  expiredInvoiceId?: Maybe<Scalars['ID']['output']>;
  newInvoiceId?: Maybe<Scalars['ID']['output']>;
};

export type Analysis = {
  attributes: Array<Attribute>;
  markers: Array<Maybe<Marker>>;
  summary: Scalars['String']['output'];
};

export type ArchiveFileEdge = {
  __typename?: 'ArchiveFileEdge';
  cursor: Scalars['String']['output'];
  node: File;
};

export type ArchiveFilesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ItemSort>;
};

export type ArchiveFilesPayload = {
  __typename?: 'ArchiveFilesPayload';
  success: Scalars['Boolean']['output'];
};

export type ArchivedFileConnection = {
  __typename?: 'ArchivedFileConnection';
  edges: Array<ArchiveFileEdge>;
  pageInfo: PageInfo;
  totalFiles: Scalars['Int']['output'];
};

export type Attribute = {
  __typename?: 'Attribute';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AudioAnalysis = Analysis & {
  __typename?: 'AudioAnalysis';
  attributes: Array<Attribute>;
  markers: Array<Maybe<Marker>>;
  summary: Scalars['String']['output'];
  tracks: Array<Track>;
  transcript: TextWithTimestamp;
};

export type AudioMatch = Match & {
  __typename?: 'AudioMatch';
  amplitudeUrl: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  end: Scalars['Float']['output'];
  file: ReportFile;
  id: Scalars['ID']['output'];
  level?: Maybe<ScoreLevel>;
  location: Scalars['String']['output'];
  markers: Array<Maybe<Marker>>;
  matchingUrl: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  start: Scalars['Float']['output'];
  stem: Stem;
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Author = EmailInvite | EntityWithRole;

export type AuthorEdge = {
  __typename?: 'AuthorEdge';
  cursor: Scalars['String']['output'];
  node: Author;
};

export type AuthorsConnection = {
  __typename?: 'AuthorsConnection';
  edges: Array<AuthorEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuthorsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<CollaboratorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailablePlans = {
  __typename?: 'AvailablePlans';
  billingCycles: Array<BillingCycle>;
  plans: Array<PlanCard>;
};

export type AvailablePlansInput = {
  origin: Scalars['String']['input'];
  platform: Platform;
};

export type Bank = {
  __typename?: 'Bank';
  accountNumber: Scalars['String']['output'];
  address: BankAddress;
  confirmation: Confirmation;
  name?: Maybe<Scalars['String']['output']>;
  recipientName: Scalars['String']['output'];
  swiftBic: Scalars['String']['output'];
};

export type BankAddress = {
  __typename?: 'BankAddress';
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type BillingCycle = {
  __typename?: 'BillingCycle';
  callout?: Maybe<I18N>;
  frequency: Frequency;
  label: I18N;
};

export enum ButtonType {
  Default = 'DEFAULT',
  Primary = 'PRIMARY'
}

export type CancelSubscriptionError = {
  __typename?: 'CancelSubscriptionError';
  code: CancelSubscriptionErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CancelSubscriptionErrorCode {
  AlreadyCancelled = 'ALREADY_CANCELLED',
  NotFound = 'NOT_FOUND'
}

export type CancelSubscriptionInput = {
  userId: Scalars['ID']['input'];
};

export type CancelSubscriptionPayload = {
  __typename?: 'CancelSubscriptionPayload';
  error?: Maybe<CancelSubscriptionError>;
  subscription?: Maybe<SubscriptionPlan>;
};

export type CardPaymentMethod = {
  __typename?: 'CardPaymentMethod';
  brand: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

export type CategoryValue = {
  __typename?: 'CategoryValue';
  name: Scalars['String']['output'];
  type: RevenueSource;
  value: Money;
};

export type ChargeUserError = {
  __typename?: 'ChargeUserError';
  code: ChargeUserErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ChargeUserErrorCode {
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR'
}

export type ChargeUserInput = {
  amount: Scalars['Int']['input'];
  currency: Scalars['Currency']['input'];
  description: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type ChargeUserPayload = {
  __typename?: 'ChargeUserPayload';
  error?: Maybe<ChargeUserError>;
  invoiceId?: Maybe<Scalars['ID']['output']>;
};

export type CoOwner = EmailInvite | EntityWithRole;

export type CoOwnerEdge = {
  __typename?: 'CoOwnerEdge';
  cursor: Scalars['String']['output'];
  node: CoOwner;
};

export type CoOwnersConnection = {
  __typename?: 'CoOwnersConnection';
  edges: Array<CoOwnerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CoOwnersInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<CollaboratorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export enum CollaboratorFilter {
  Accepted = 'ACCEPTED',
  All = 'ALL'
}

export enum ComparisonPeriod {
  Custom = 'CUSTOM',
  PreviousMonth = 'PREVIOUS_MONTH',
  PreviousPeriod = 'PREVIOUS_PERIOD',
  PreviousWeek = 'PREVIOUS_WEEK',
  PreviousYear = 'PREVIOUS_YEAR'
}

export type CompleteTipPayload = {
  __typename?: 'CompleteTipPayload';
  success: Scalars['Boolean']['output'];
};

export type ConfirmOriginBankDetailsError = {
  __typename?: 'ConfirmOriginBankDetailsError';
  code: ConfirmOriginBankDetailsErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ConfirmOriginBankDetailsErrorCode {
  OriginNotFound = 'ORIGIN_NOT_FOUND',
  WireDetailsNotSet = 'WIRE_DETAILS_NOT_SET'
}

export type ConfirmOriginBankDetailsPayload = {
  __typename?: 'ConfirmOriginBankDetailsPayload';
  error?: Maybe<ConfirmOriginBankDetailsError>;
  origin?: Maybe<Origin>;
};

export type Confirmation = {
  __typename?: 'Confirmation';
  confirmed: Scalars['Boolean']['output'];
  confirmedBy?: Maybe<User>;
};

export type Coords = {
  __typename?: 'Coords';
  page: Scalars['Int']['output'];
  x1: Scalars['Float']['output'];
  x2: Scalars['Float']['output'];
  y1: Scalars['Float']['output'];
  y2: Scalars['Float']['output'];
};

export type CopyrightNotificationDetails = {
  __typename?: 'CopyrightNotificationDetails';
  file: File;
};

export type CopyrightOwner = {
  __typename?: 'CopyrightOwner';
  avatar: Image;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: CopyrightOwnerType;
};

export enum CopyrightOwnerType {
  Account = 'ACCOUNT',
  Organization = 'ORGANIZATION',
  Personal = 'PERSONAL'
}

export enum CopyrightStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE',
  Processing = 'PROCESSING'
}

export type CreateFeedbackInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  rating: FeedbackRating;
  referenceId: Scalars['ID']['input'];
  type: FeedbackType;
};

export type CreateFeedbackPayload = {
  __typename?: 'CreateFeedbackPayload';
  feedbackId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateFolderError = {
  __typename?: 'CreateFolderError';
  code: CreateFolderErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CreateFolderErrorCode {
  InUse = 'IN_USE'
}

export type CreateFolderInput = {
  name: Scalars['String']['input'];
  parentId: Scalars['ID']['input'];
};

export type CreateFolderPayload = {
  __typename?: 'CreateFolderPayload';
  error?: Maybe<CreateFolderError>;
  folder?: Maybe<Folder>;
};

export type CreateNoteInput = {
  content: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  origin: Scalars['String']['input'];
};

export type CreateNotePayload = {
  __typename?: 'CreateNotePayload';
  note: Note;
};

export type CreatePlanError = {
  __typename?: 'CreatePlanError';
  code: CreatePlanErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CreatePlanErrorCode {
  Unauthorized = 'UNAUTHORIZED',
  ValidationError = 'VALIDATION_ERROR'
}

export type CreatePlanGroupError = {
  __typename?: 'CreatePlanGroupError';
  code: CreatePlanGroupErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CreatePlanGroupErrorCode {
  Unauthorized = 'UNAUTHORIZED',
  ValidationError = 'VALIDATION_ERROR'
}

export type CreatePlanGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  origin: Scalars['String']['input'];
};

export type CreatePlanGroupPayload = {
  __typename?: 'CreatePlanGroupPayload';
  error?: Maybe<CreatePlanGroupError>;
  planGroup?: Maybe<PlanGroup>;
};

export type CreatePlanInput = {
  enabledPlatforms: Array<Platform>;
  group: Scalars['String']['input'];
  name: Scalars['String']['input'];
  origin: Scalars['String']['input'];
  type: PlanType;
};

export type CreatePlanPayload = {
  __typename?: 'CreatePlanPayload';
  error?: Maybe<CreatePlanError>;
  plan?: Maybe<PlanSummary>;
};

export type CreateReportError = {
  __typename?: 'CreateReportError';
  code: CreateReportErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CreateReportErrorCode {
  ComparingFileNotFound = 'COMPARING_FILE_NOT_FOUND',
  CopyrightNotFound = 'COPYRIGHT_NOT_FOUND',
  LimitExceeded = 'LIMIT_EXCEEDED'
}

export type CreateReportInput = {
  comparingId: Scalars['ID']['input'];
  copyrightId: Scalars['ID']['input'];
};

export type CreateReportPayload = {
  __typename?: 'CreateReportPayload';
  error?: Maybe<CreateReportError>;
  success: Scalars['Boolean']['output'];
};

export type CrossBorderDataPoint = {
  __typename?: 'CrossBorderDataPoint';
  inbound: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  outbound: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type CrossBorderOverTime = {
  __typename?: 'CrossBorderOverTime';
  inbound: CrossBorderSummary;
  outbound: CrossBorderSummary;
  previousSeries?: Maybe<Array<CrossBorderDataPoint>>;
  series: Array<CrossBorderDataPoint>;
};

export type CrossBorderOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  origin: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};

export type CrossBorderSummary = {
  __typename?: 'CrossBorderSummary';
  change?: Maybe<PercentChange>;
  value: Scalars['Int']['output'];
};

export type CurrencyRevenue = {
  __typename?: 'CurrencyRevenue';
  amount: Money;
  currency: Scalars['Currency']['output'];
  name: Scalars['String']['output'];
};

export type DeactivateAccountError = {
  __typename?: 'DeactivateAccountError';
  code: DeactivateAccountErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum DeactivateAccountErrorCode {
  UserNotFound = 'USER_NOT_FOUND'
}

export type DeactivateAccountPayload = {
  __typename?: 'DeactivateAccountPayload';
  error?: Maybe<DeactivateAccountError>;
  success: Scalars['Boolean']['output'];
};

export type DeleteAccountError = {
  __typename?: 'DeleteAccountError';
  code: DeleteAccountErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum DeleteAccountErrorCode {
  UserNotFound = 'USER_NOT_FOUND'
}

export type DeleteAccountPayload = {
  __typename?: 'DeleteAccountPayload';
  error?: Maybe<DeleteAccountError>;
  success: Scalars['Boolean']['output'];
};

export enum DeleteCopyrightOwnerErrorCode {
  CopyrightOwnerNotFound = 'COPYRIGHT_OWNER_NOT_FOUND'
}

export type DeleteCopyrightOwnerInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCopyrightOwnerPayload = {
  __typename?: 'DeleteCopyrightOwnerPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteFoldersError = {
  __typename?: 'DeleteFoldersError';
  code: DeleteFoldersErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum DeleteFoldersErrorCode {
  NotEmpty = 'NOT_EMPTY'
}

export type DeleteFoldersPayload = {
  __typename?: 'DeleteFoldersPayload';
  error?: Maybe<DeleteFoldersError>;
  success: Scalars['Boolean']['output'];
};

export type DeleteNoteInput = {
  id: Scalars['ID']['input'];
};

export type DeleteNotePayload = {
  __typename?: 'DeleteNotePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteUserError = {
  __typename?: 'DeleteUserError';
  code: DeleteUserErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum DeleteUserErrorCode {
  UserNotFound = 'USER_NOT_FOUND'
}

export type DeleteUserInput = {
  userId: Scalars['ID']['input'];
};

export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  error?: Maybe<DeleteUserError>;
  success: Scalars['Boolean']['output'];
};

export type DocumentAsset = FileAsset & {
  __typename?: 'DocumentAsset';
  documentUrl?: Maybe<Scalars['String']['output']>;
  previewImageUrl: Scalars['String']['output'];
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type DocumentUrl = {
  __typename?: 'DocumentUrl';
  page: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type EmailInvite = {
  __typename?: 'EmailInvite';
  email: Scalars['String']['output'];
};

export type Entity = Organization | User;

export enum EntityType {
  User = 'USER'
}

export type EntityWithRole = {
  __typename?: 'EntityWithRole';
  entity: Entity;
  role: FileRole;
};

export type EstimateRegistrationCost = {
  __typename?: 'EstimateRegistrationCost';
  breakdown: Array<RegistrationCost>;
  total: Money;
};

export type EstimateRegistrationCostInput = {
  origins: Array<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
};

export type Exchange = {
  __typename?: 'Exchange';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  renderedPrice: Scalars['String']['output'];
};

export type ExchangeInput = {
  amount: Scalars['Float']['input'];
  fromCurrency: Scalars['String']['input'];
  toCurrency: Scalars['String']['input'];
};

export type ExtendSubscriptionError = {
  __typename?: 'ExtendSubscriptionError';
  code: ExtendSubscriptionErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ExtendSubscriptionErrorCode {
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR'
}

export type ExtendSubscriptionInput = {
  months: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type ExtendSubscriptionPayload = {
  __typename?: 'ExtendSubscriptionPayload';
  error?: Maybe<ExtendSubscriptionError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum FeedbackRating {
  Down = 'DOWN',
  Up = 'UP'
}

export enum FeedbackType {
  Analysis = 'ANALYSIS',
  Report = 'REPORT'
}

export type File = {
  __typename?: 'File';
  analysis?: Maybe<Analysis>;
  archivedAt?: Maybe<Scalars['Timestamp']['output']>;
  asset?: Maybe<FileAsset>;
  authors: AuthorsConnection;
  coOwners: CoOwnersConnection;
  copyright: FileCopyright;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata: FileMetadata;
  name: Scalars['String']['output'];
  notifications: Array<Maybe<Notification>>;
  owner: Entity;
  permissions: Array<FilePermission>;
  registrant: User;
  role: FileRole;
  settings: FileSettings;
  type: FileType;
  viewers: ViewersConnection;
};


export type FileAuthorsArgs = {
  input: AuthorsInput;
};


export type FileCoOwnersArgs = {
  input: CoOwnersInput;
};


export type FileViewersArgs = {
  input: ViewersInput;
};

export type FileAsset = {
  previewImageUrl: Scalars['String']['output'];
};

export enum FileCategory {
  Audio = 'AUDIO',
  Code = 'CODE',
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Other = 'OTHER',
  Video = 'VIDEO'
}

export type FileCategoryCount = {
  __typename?: 'FileCategoryCount';
  category: FileCategory;
  count: Scalars['Int']['output'];
};

export type FileCopyright = {
  __typename?: 'FileCopyright';
  id?: Maybe<Scalars['ID']['output']>;
  registrations: Array<FileRegistration>;
  status: CopyrightStatus;
};

export type FileEdge = {
  __typename?: 'FileEdge';
  cursor: Scalars['String']['output'];
  node: File;
};

export type FileMetadata = {
  __typename?: 'FileMetadata';
  originalFilename: Scalars['String']['output'];
  size: Scalars['String']['output'];
};

export type FileMetadataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  isPrivate: Scalars['Boolean']['input'];
  size: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum FilePermission {
  Archive = 'ARCHIVE',
  Download = 'DOWNLOAD',
  Edit = 'EDIT',
  Invite = 'INVITE',
  Privacy = 'PRIVACY',
  View = 'VIEW'
}

export enum FilePrivacy {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type FileRegistration = {
  __typename?: 'FileRegistration';
  certificateUrl?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Timestamp']['output']>;
  origin: Origin;
  timestamp?: Maybe<Scalars['Timestamp']['output']>;
};

export enum FileRole {
  Author = 'AUTHOR',
  CoOwner = 'CO_OWNER',
  Invited = 'INVITED',
  Owner = 'OWNER',
  Public = 'PUBLIC',
  Viewer = 'VIEWER'
}

export type FileSettings = {
  __typename?: 'FileSettings';
  isPrivate: Scalars['Boolean']['output'];
};

export type FileSort = {
  direction: SortDirection;
  field: FileSortField;
};

export enum FileSortField {
  ArchivedAt = 'ARCHIVED_AT',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export enum FileType {
  AdobeAfterEffects = 'ADOBE_AFTER_EFFECTS',
  AdobeAudition = 'ADOBE_AUDITION',
  AdobeIllustrator = 'ADOBE_ILLUSTRATOR',
  AdobeIndesign = 'ADOBE_INDESIGN',
  AdobePhotoshop = 'ADOBE_PHOTOSHOP',
  AdobePremierPro = 'ADOBE_PREMIER_PRO',
  Audio = 'AUDIO',
  AutodeskAutocad = 'AUTODESK_AUTOCAD',
  AutodeskFusion = 'AUTODESK_FUSION',
  AutodeskMaya = 'AUTODESK_MAYA',
  Cinema_4D = 'CINEMA_4D',
  Code = 'CODE',
  DavinciResolve = 'DAVINCI_RESOLVE',
  Generic = 'GENERIC',
  Image = 'IMAGE',
  MsAccess = 'MS_ACCESS',
  MsExcel = 'MS_EXCEL',
  MsPowerPoint = 'MS_POWER_POINT',
  MsPublisher = 'MS_PUBLISHER',
  MsWord = 'MS_WORD',
  Pdf = 'PDF',
  Table = 'TABLE',
  Text = 'TEXT',
  ThreeD = 'THREE_D',
  Vector = 'VECTOR',
  Video = 'VIDEO',
  Zip = 'ZIP'
}

export type FilesByCategoryInput = {
  endDate: Scalars['Date']['input'];
  origin: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};

export type FilesComparison = {
  __typename?: 'FilesComparison';
  change: PercentChange;
  total: Scalars['Int']['output'];
};

export type FilesConnection = {
  __typename?: 'FilesConnection';
  edges: Array<FileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalStorage: Scalars['String']['output'];
};

export type FilesDataPoint = {
  __typename?: 'FilesDataPoint';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type FilesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  origin: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<FileSort>;
};

export type FilesOverTime = {
  __typename?: 'FilesOverTime';
  comparison?: Maybe<FilesComparison>;
  previousSeries?: Maybe<Array<FilesDataPoint>>;
  series: Array<FilesDataPoint>;
  total: Scalars['Int']['output'];
};

export type FilesOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type Folder = {
  __typename?: 'Folder';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  items: ItemsConnection;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  totalFiles: Scalars['Int']['output'];
};


export type FolderItemsArgs = {
  input: FolderItemsInput;
};

export type FolderItemsFilterInput = {
  type?: InputMaybe<ItemType>;
};

export type FolderItemsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<FolderItemsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ItemSort>;
};

export enum Frequency {
  Month = 'MONTH',
  OneTime = 'ONE_TIME',
  Year = 'YEAR'
}

export type GenerateInvoicePayload = {
  __typename?: 'GenerateInvoicePayload';
  url: Scalars['String']['output'];
};

export type GenericAnalysis = Analysis & {
  __typename?: 'GenericAnalysis';
  attributes: Array<Attribute>;
  markers: Array<Maybe<Marker>>;
  summary: Scalars['String']['output'];
};

export type GetAvatarUploadUrlInput = {
  fileName: Scalars['String']['input'];
};

export type GetAvatarUploadUrlPayload = {
  __typename?: 'GetAvatarUploadUrlPayload';
  headers?: Maybe<Scalars['JSON']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GetOriginAssetUploadUrlInput = {
  assetKey: OriginAssetKey;
  fileName: Scalars['String']['input'];
  originId: Scalars['ID']['input'];
};

export type GetOriginAssetUploadUrlPayload = {
  __typename?: 'GetOriginAssetUploadUrlPayload';
  headers?: Maybe<Scalars['Json']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GiveFreeFilesError = {
  __typename?: 'GiveFreeFilesError';
  code: GiveFreeFilesErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum GiveFreeFilesErrorCode {
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR'
}

export type GiveFreeFilesInput = {
  count: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type GiveFreeFilesPayload = {
  __typename?: 'GiveFreeFilesPayload';
  error?: Maybe<GiveFreeFilesError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GovLeaderboardEntry = {
  __typename?: 'GovLeaderboardEntry';
  amount: Money;
  origin: Origin;
};

export type GovLeaderboardInput = {
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  first: Scalars['Int']['input'];
  revenueType: RevenueType;
  startDate: Scalars['Date']['input'];
  taxType: RevenueSource;
};

export type I18N = {
  __typename?: 'I18N';
  key: Scalars['String']['output'];
};

export type IapPaymentMethod = {
  __typename?: 'IAPPaymentMethod';
  provider: Platform;
};

export enum IdentityVerificationType {
  Document = 'DOCUMENT',
  IdNumber = 'ID_NUMBER'
}

export type Image = {
  __typename?: 'Image';
  url: Scalars['String']['output'];
};

export type ImageAsset = FileAsset & {
  __typename?: 'ImageAsset';
  previewImageUrl: Scalars['String']['output'];
};

export type ImageMatch = Match & {
  __typename?: 'ImageMatch';
  coords?: Maybe<Array<Scalars['String']['output']>>;
  file: ReportFile;
  id: Scalars['ID']['output'];
  level?: Maybe<ScoreLevel>;
  location: Scalars['String']['output'];
  markers: Array<Maybe<Marker>>;
  score?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Infringement = {
  __typename?: 'Infringement';
  copyrights: Array<File>;
  id: Scalars['ID']['output'];
  infringingFile: InfringingFile;
  label: InfringementLabel;
  matches?: Maybe<MatchSummary>;
  report?: Maybe<Report>;
  timestamp: Scalars['Timestamp']['output'];
};

export type InfringementConnection = {
  __typename?: 'InfringementConnection';
  edges: Array<InfringementEdge>;
  pageInfo: PageInfo;
  totalFlags: Scalars['Int']['output'];
  totalReports: Scalars['Int']['output'];
};

export type InfringementEdge = {
  __typename?: 'InfringementEdge';
  cursor: Scalars['String']['output'];
  node: Infringement;
};

export enum InfringementLabel {
  Flag = 'FLAG',
  Report = 'REPORT'
}

export enum InfringementSortField {
  Score = 'SCORE',
  Timestamp = 'TIMESTAMP'
}

export type InfringementsFilterBy = {
  group?: InputMaybe<InfringementsGroupFilterBy>;
  type?: InputMaybe<InfringementLabel>;
};

export type InfringementsGroupFilterBy = {
  id: Scalars['ID']['input'];
  timestamp: Scalars['Timestamp']['input'];
};

export type InfringementsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<InfringementsFilterBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<InfringementsSort>;
};

export type InfringementsSort = {
  direction: SortDirection;
  field: InfringementSortField;
};

export type InfringingFile = {
  __typename?: 'InfringingFile';
  asset: FileAsset;
  attributes: Array<Attribute>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: FileType;
};

export type InviteInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type: InviteType;
};

export type InviteNotificationDetails = {
  __typename?: 'InviteNotificationDetails';
  file: File;
  from: User;
};

export enum InviteType {
  Email = 'EMAIL',
  Org = 'ORG',
  User = 'USER'
}

export type InvitedEmail = {
  __typename?: 'InvitedEmail';
  email: Scalars['String']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  date?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  periodEnd: Scalars['Timestamp']['output'];
  periodStart: Scalars['Timestamp']['output'];
  price: Pricing;
  status: InvoiceStatus;
  url?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  edges: Array<InvoiceEdge>;
  pageInfo: PageInfo;
};

export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  cursor: Scalars['String']['output'];
  node: Invoice;
};

export enum InvoiceStatus {
  Expired = 'EXPIRED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Refunded = 'REFUNDED'
}

export type InvoicesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type Item = File | Folder;

export type ItemEdge = {
  __typename?: 'ItemEdge';
  cursor: Scalars['String']['output'];
  node: Item;
};

export enum ItemSort {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  TimestampAsc = 'TIMESTAMP_ASC',
  TimestampDesc = 'TIMESTAMP_DESC'
}

export enum ItemType {
  File = 'FILE',
  Folder = 'FOLDER'
}

export type ItemsConnection = {
  __typename?: 'ItemsConnection';
  edges: Array<ItemEdge>;
  pageInfo: PageInfo;
  totalFiles: Scalars['Int']['output'];
};

export type Logo = {
  __typename?: 'Logo';
  black: Image;
  white: Image;
};

export type MarkAllNotificationsAsReadPayload = {
  __typename?: 'MarkAllNotificationsAsReadPayload';
  success: Scalars['Boolean']['output'];
};

export type MarkNotificationsAsReadInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type MarkNotificationsAsReadPayload = {
  __typename?: 'MarkNotificationsAsReadPayload';
  success: Scalars['Boolean']['output'];
};

export type Marker = {
  __typename?: 'Marker';
  color: Scalars['String']['output'];
  shine: Scalars['Boolean']['output'];
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type Match = {
  file: ReportFile;
  id: Scalars['ID']['output'];
  level?: Maybe<ScoreLevel>;
  location: Scalars['String']['output'];
  markers: Array<Maybe<Marker>>;
  score?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MatchCategory = {
  __typename?: 'MatchCategory';
  breakdown: Array<MatchCategoryBreakdown>;
  summary?: Maybe<MatchCategorySummary>;
  type: MatchCategoryType;
};

export type MatchCategoryBreakdown = {
  __typename?: 'MatchCategoryBreakdown';
  copyright: Match;
  infringingFile: Match;
};

export type MatchCategorySummary = {
  __typename?: 'MatchCategorySummary';
  copyright: Scalars['String']['output'];
  infringingFile: Scalars['String']['output'];
};

export enum MatchCategoryType {
  Audio = 'AUDIO',
  Image = 'IMAGE',
  Text = 'TEXT',
  Transcript = 'TRANSCRIPT',
  Video = 'VIDEO'
}

export type MatchSummary = {
  __typename?: 'MatchSummary';
  breakdown: Array<MatchSummaryBreakdown>;
  level: ScoreLevel;
  score: Scalars['Float']['output'];
};

export type MatchSummaryBreakdown = {
  __typename?: 'MatchSummaryBreakdown';
  level: ScoreLevel;
  score: Scalars['Float']['output'];
  type: MatchCategoryType;
};

export type Matches = {
  __typename?: 'Matches';
  categories: Array<MatchCategory>;
  total: Scalars['Int']['output'];
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['String']['output'];
  currency: Scalars['Currency']['output'];
  formatted: Scalars['String']['output'];
};

export type MoveItemsInput = {
  folderId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type MoveItemsPayload = {
  __typename?: 'MoveItemsPayload';
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAuthors: AddAuthorsPayload;
  addCoOwners: AddCoOwnersPayload;
  addCopyrightOwner: AddCopyrightOwnerPayload;
  addReportViewers: AddReportViewersPayload;
  addTeamMember: AddTeamMemberPayload;
  addViewers: AddViewersPayload;
  adjustOverdueInvoice: AdjustOverdueInvoicePayload;
  archiveFiles: ArchiveFilesPayload;
  cancelSubscription: CancelSubscriptionPayload;
  chargeUser: ChargeUserPayload;
  completeTip: CompleteTipPayload;
  confirmOriginBankDetails: ConfirmOriginBankDetailsPayload;
  createFeedback: CreateFeedbackPayload;
  createFolder: CreateFolderPayload;
  createNote: CreateNotePayload;
  createPlan: CreatePlanPayload;
  createPlanGroup: CreatePlanGroupPayload;
  createReport: CreateReportPayload;
  deactivateAccount: DeactivateAccountPayload;
  deleteAccount: DeleteAccountPayload;
  deleteCopyrightOwner: DeleteCopyrightOwnerPayload;
  deleteFolders: DeleteFoldersPayload;
  deleteNote: DeleteNotePayload;
  deleteUser: DeleteUserPayload;
  extendSubscription: ExtendSubscriptionPayload;
  generateInvoice: GenerateInvoicePayload;
  getAvatarUploadUrl: GetAvatarUploadUrlPayload;
  getOriginAssetUploadUrl: GetOriginAssetUploadUrlPayload;
  giveFreeFiles: GiveFreeFilesPayload;
  markAllNotificationsAsRead: MarkAllNotificationsAsReadPayload;
  markNotificationsAsRead: MarkNotificationsAsReadPayload;
  moveItems: MoveItemsPayload;
  payBalance: PayBalancePayload;
  purchaseReportCredits: PurchaseReportCreditsPayload;
  refundUser: RefundUserPayload;
  removeAuthor: RemoveAuthorsPayload;
  removeCoOwner: RemoveCoOwnerPayload;
  removeReportViewer: RemoveReportViewerPayload;
  removeTeamMember: RemoveTeamMemberPayload;
  removeViewer: RemoveViewersPayload;
  renameFolder: RenameFolderPayload;
  subscribe: SubscribePayload;
  updateCopyrightOwner: UpdateCopyrightOwnerPayload;
  updateEmail: UpdateEmailPayload;
  updateFileSettings: UpdateFileSettingsPayload;
  updateNote: UpdateNotePayload;
  updateOrigin: UpdateOriginPayload;
  updateOriginBank: UpdateOriginBankPayload;
  updateOriginPortal: UpdateOriginPortalPayload;
  updatePaymentMethod: UpdatePaymentMethodPayload;
  updatePlan: UpdatePlanPayload;
  updateProfile: UpdateProfilePayload;
  updateReportSettings: UpdateReportSettingsPayload;
  updateSettings: UpdateSettingsPayload;
  updateSubscription: UpdateSubscriptionPayload;
  updateTeamMember: UpdateTeamMemberPayload;
  updateViewerPermissions: UpdateViewerPermissionsPayload;
  upload: UploadPayload;
  uploadInfringingFile: UploadInfringingFilePayload;
  verifyIdentity: VerifyIdentityPayload;
  voidInvoice: VoidInvoicePayload;
};


export type MutationAddAuthorsArgs = {
  input: AddAuthorsInput;
};


export type MutationAddCoOwnersArgs = {
  input: AddCoOwnersInput;
};


export type MutationAddCopyrightOwnerArgs = {
  input: AddCopyrightOwnerInput;
};


export type MutationAddReportViewersArgs = {
  input: AddReportViewersInput;
};


export type MutationAddTeamMemberArgs = {
  input: AddTeamMemberInput;
};


export type MutationAddViewersArgs = {
  input: AddViewersInput;
};


export type MutationAdjustOverdueInvoiceArgs = {
  input: AdjustOverdueInvoiceInput;
};


export type MutationArchiveFilesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationChargeUserArgs = {
  input: ChargeUserInput;
};


export type MutationCompleteTipArgs = {
  name: TipName;
};


export type MutationConfirmOriginBankDetailsArgs = {
  originId: Scalars['ID']['input'];
};


export type MutationCreateFeedbackArgs = {
  input: CreateFeedbackInput;
};


export type MutationCreateFolderArgs = {
  input: CreateFolderInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
};


export type MutationCreatePlanGroupArgs = {
  input: CreatePlanGroupInput;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationDeleteCopyrightOwnerArgs = {
  input: DeleteCopyrightOwnerInput;
};


export type MutationDeleteFoldersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteNoteArgs = {
  input: DeleteNoteInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationExtendSubscriptionArgs = {
  input: ExtendSubscriptionInput;
};


export type MutationGenerateInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGetAvatarUploadUrlArgs = {
  input: GetAvatarUploadUrlInput;
};


export type MutationGetOriginAssetUploadUrlArgs = {
  input: GetOriginAssetUploadUrlInput;
};


export type MutationGiveFreeFilesArgs = {
  input: GiveFreeFilesInput;
};


export type MutationMarkNotificationsAsReadArgs = {
  input: MarkNotificationsAsReadInput;
};


export type MutationMoveItemsArgs = {
  input: MoveItemsInput;
};


export type MutationPurchaseReportCreditsArgs = {
  input: PurchaseReportCreditsInput;
};


export type MutationRefundUserArgs = {
  input: RefundUserInput;
};


export type MutationRemoveAuthorArgs = {
  input: RemoveAuthorInput;
};


export type MutationRemoveCoOwnerArgs = {
  input: RemoveCoOwnerInput;
};


export type MutationRemoveReportViewerArgs = {
  input: RemoveReportViewerInput;
};


export type MutationRemoveTeamMemberArgs = {
  input: RemoveTeamMemberInput;
};


export type MutationRemoveViewerArgs = {
  input: RemoveViewerInput;
};


export type MutationRenameFolderArgs = {
  input: RenameFolderInput;
};


export type MutationSubscribeArgs = {
  input: SubscribeInput;
};


export type MutationUpdateCopyrightOwnerArgs = {
  input: UpdateCopyrightOwnerInput;
};


export type MutationUpdateEmailArgs = {
  input: UpdateEmailInput;
};


export type MutationUpdateFileSettingsArgs = {
  input: UpdateFileSettingsInput;
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


export type MutationUpdateOriginArgs = {
  input: UpdateOriginInput;
};


export type MutationUpdateOriginBankArgs = {
  input: UpdateOriginBankInput;
};


export type MutationUpdateOriginPortalArgs = {
  input: UpdateOriginPortalInput;
};


export type MutationUpdatePaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type MutationUpdatePlanArgs = {
  input: UpdatePlanInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateReportSettingsArgs = {
  input: UpdateReportSettingsInput;
};


export type MutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateTeamMemberArgs = {
  input: UpdateTeamMemberInput;
};


export type MutationUpdateViewerPermissionsArgs = {
  input: UpdateViewerPermissionsInput;
};


export type MutationUploadArgs = {
  input: UploadInput;
};


export type MutationUploadInfringingFileArgs = {
  input: UploadInfringingFileInput;
};


export type MutationVerifyIdentityArgs = {
  input: VerifyIdentityInput;
};


export type MutationVoidInvoiceArgs = {
  input: VoidInvoiceInput;
};

export type Note = {
  __typename?: 'Note';
  author: User;
  content: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  origin: Scalars['String']['output'];
};

export type NoteConnection = {
  __typename?: 'NoteConnection';
  edges: Array<NoteEdge>;
  pageInfo: PageInfo;
};

export type NoteEdge = {
  __typename?: 'NoteEdge';
  cursor: Scalars['String']['output'];
  node: Note;
};

export type Notification = {
  __typename?: 'Notification';
  actions: Array<NotificationAction>;
  content: I18N;
  details?: Maybe<NotificationDetails>;
  id: Scalars['ID']['output'];
  read: Scalars['Boolean']['output'];
  timestamp: Scalars['Timestamp']['output'];
  type: NotificationType;
};

export type NotificationAction = {
  __typename?: 'NotificationAction';
  buttonType: ButtonType;
  label: I18N;
  type: NotificationActionType;
};

export enum NotificationActionType {
  AcceptAuthorRequest = 'ACCEPT_AUTHOR_REQUEST',
  AcceptOwnerRequest = 'ACCEPT_OWNER_REQUEST',
  DeclineAuthorRequest = 'DECLINE_AUTHOR_REQUEST',
  DeclineOwnerRequest = 'DECLINE_OWNER_REQUEST'
}

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
  totalUnread: Scalars['Int']['output'];
};

export type NotificationDetails = CopyrightNotificationDetails | InviteNotificationDetails;

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String']['output'];
  node: Notification;
};

export enum NotificationType {
  AccountPaymentFailed = 'ACCOUNT_PAYMENT_FAILED',
  AccountPaymentRequiresAction = 'ACCOUNT_PAYMENT_REQUIRES_ACTION',
  AuthorInviteAccepted = 'AUTHOR_INVITE_ACCEPTED',
  AuthorInvitePending = 'AUTHOR_INVITE_PENDING',
  AuthorRemoved = 'AUTHOR_REMOVED',
  OwnerInviteAccepted = 'OWNER_INVITE_ACCEPTED',
  OwnerInvitePending = 'OWNER_INVITE_PENDING',
  OwnerRemoved = 'OWNER_REMOVED',
  UploadEmptyFile = 'UPLOAD_EMPTY_FILE',
  UploadFailed = 'UPLOAD_FAILED',
  ViewerAdded = 'VIEWER_ADDED',
  Welcome = 'WELCOME'
}

export type NotificationsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type OnboardingStatus = {
  __typename?: 'OnboardingStatus';
  completed: Scalars['Boolean']['output'];
  nextStep?: Maybe<OnboardingStep>;
};

export type OnboardingStep = {
  __typename?: 'OnboardingStep';
  id: Scalars['ID']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  avatar: Image;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: Entity;
};

export type Origin = {
  __typename?: 'Origin';
  activePlans: Scalars['Int']['output'];
  avatar: Image;
  bank?: Maybe<Bank>;
  currency: Scalars['String']['output'];
  fees: Array<OriginFee>;
  flag: Image;
  id: Scalars['ID']['output'];
  logo: Logo;
  name: Scalars['String']['output'];
  portal?: Maybe<OriginPortal>;
  registrationCost?: Maybe<RegistrationCost>;
  registrationRevenue: Money;
  storageUsed: Scalars['String']['output'];
  subscriptionRevenue: Money;
  supportedDomains: Array<Scalars['String']['output']>;
  taxRevenue: Money;
  team: Array<TeamMember>;
  totalRegistrations: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  useCurrency: Scalars['Boolean']['output'];
};


export type OriginRegistrationRevenueArgs = {
  currency: Scalars['Currency']['input'];
};


export type OriginSubscriptionRevenueArgs = {
  currency: Scalars['Currency']['input'];
};


export type OriginTaxRevenueArgs = {
  currency: Scalars['Currency']['input'];
};

export enum OriginAssetKey {
  Avatar = 'AVATAR',
  Favicon = 'FAVICON',
  Flag = 'FLAG',
  LogoBlack = 'LOGO_BLACK',
  LogoWhite = 'LOGO_WHITE',
  MainArtwork = 'MAIN_ARTWORK',
  ShareImage = 'SHARE_IMAGE'
}

export type OriginFee = {
  __typename?: 'OriginFee';
  amount?: Maybe<OriginFeeAmount>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Int']['output']>;
  status: OriginFeeStatus;
  structure: OriginFeeStructure;
  type: OriginFeeType;
};

export type OriginFeeAmount = {
  __typename?: 'OriginFeeAmount';
  currency: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum OriginFeeStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum OriginFeeStructure {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export enum OriginFeeType {
  CrossBorder = 'CROSS_BORDER',
  Custom = 'CUSTOM',
  Recognition = 'RECOGNITION',
  Registration = 'REGISTRATION'
}

export type OriginPortal = {
  __typename?: 'OriginPortal';
  buttonText?: Maybe<Scalars['String']['output']>;
  calloutLinkText?: Maybe<Scalars['String']['output']>;
  calloutLinkUrl?: Maybe<Scalars['String']['output']>;
  calloutText?: Maybe<Scalars['String']['output']>;
  faqs?: Maybe<Array<OriginPortalFaq>>;
  favicon?: Maybe<Image>;
  mainArtwork?: Maybe<Image>;
  shareDescription?: Maybe<Scalars['String']['output']>;
  shareImage?: Maybe<Image>;
  shareTitle?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OriginPortalFaq = {
  __typename?: 'OriginPortalFaq';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PayBalanceError = {
  __typename?: 'PayBalanceError';
  code: PayBalanceErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PayBalanceErrorCode {
  InsufficientFunds = 'INSUFFICIENT_FUNDS'
}

export type PayBalancePayload = {
  __typename?: 'PayBalancePayload';
  error?: Maybe<PayBalanceError>;
  subscription?: Maybe<SubscriptionPlan>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  card?: Maybe<CardPaymentMethod>;
  iap?: Maybe<IapPaymentMethod>;
};

export enum PaymentStatus {
  Chargeback = 'CHARGEBACK',
  Refunded = 'REFUNDED',
  Successful = 'SUCCESSFUL'
}

export type PaymentStatusBreakdown = {
  __typename?: 'PaymentStatusBreakdown';
  amount: Money;
  label: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  status: PaymentStatus;
};

export type PaymentStatusBreakdownInput = {
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  origin: Scalars['ID']['input'];
  revenueType: RevenueType;
  startDate: Scalars['Date']['input'];
};

export type PercentChange = {
  __typename?: 'PercentChange';
  isPositive: Scalars['Boolean']['output'];
  value: Scalars['Float']['output'];
};

export enum Permission {
  Admin = 'ADMIN',
  Affiliate = 'AFFILIATE',
  CopyrightOwners = 'COPYRIGHT_OWNERS',
  Payments = 'PAYMENTS',
  Pro = 'PRO',
  Upload = 'UPLOAD'
}

export type Plan = {
  __typename?: 'Plan';
  description: Scalars['String']['output'];
  freeUnits?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  origin: Origin;
  platform: Platform;
  pricingTiers: Array<PricingTier>;
  revenueOverTime: PlanRevenueOverTime;
  status: PlanStatus;
  subscribers: Scalars['Int']['output'];
  subscribersOverTime: PlanSubscribersOverTime;
  subscriptionRevenue: Money;
  type: PlanType;
};


export type PlanRevenueOverTimeArgs = {
  input: PlanRevenueOverTimeInput;
};


export type PlanSubscribersOverTimeArgs = {
  input: PlanSubscribersOverTimeInput;
};


export type PlanSubscriptionRevenueArgs = {
  currency: Scalars['Currency']['input'];
};

export type PlanCard = {
  __typename?: 'PlanCard';
  callout?: Maybe<Scalars['String']['output']>;
  highlight: Scalars['Boolean']['output'];
  includes: Array<PlanInclude>;
  plan: Plan;
  pricing: PlanCardPricing;
  upsell?: Maybe<PlanUpsell>;
};

export type PlanCardPricing = {
  __typename?: 'PlanCardPricing';
  copyrightPrice?: Maybe<Scalars['String']['output']>;
  copyrightPriceQualifier?: Maybe<Scalars['String']['output']>;
  subscriptionPrice: Scalars['String']['output'];
  subscriptionPriceQualifier?: Maybe<Scalars['String']['output']>;
};

export type PlanEdge = {
  __typename?: 'PlanEdge';
  cursor: Scalars['String']['output'];
  node: PlanSummary;
};

export type PlanGroup = {
  __typename?: 'PlanGroup';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  origin: Origin;
  planCount: Scalars['Int']['output'];
  status: PlanGroupStatus;
};

export enum PlanGroupStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type PlanInclude = {
  __typename?: 'PlanInclude';
  description?: Maybe<Scalars['String']['output']>;
  link?: Maybe<PlanIncludeLink>;
  separator?: Maybe<Scalars['Boolean']['output']>;
  text: Scalars['String']['output'];
};

export type PlanIncludeLink = {
  __typename?: 'PlanIncludeLink';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PlanPricing = {
  __typename?: 'PlanPricing';
  copyright?: Maybe<Pricing>;
  subscription: Pricing;
};

export type PlanRevenueDataPoint = {
  __typename?: 'PlanRevenueDataPoint';
  label: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  value: Money;
};

export type PlanRevenueOverTime = {
  __typename?: 'PlanRevenueOverTime';
  series: Array<PlanRevenueDataPoint>;
  total: Money;
};

export type PlanRevenueOverTimeInput = {
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export enum PlanStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE'
}

export type PlanSubscribersOverTime = {
  __typename?: 'PlanSubscribersOverTime';
  cancelled: Scalars['Int']['output'];
  new: Scalars['Int']['output'];
  series: Array<SubscriberDataPoint>;
};

export type PlanSubscribersOverTimeInput = {
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type PlanSummary = {
  __typename?: 'PlanSummary';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  enabledPlatforms: Array<Platform>;
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  origin: Origin;
  plans: Array<PlanCard>;
  status: PlanStatus;
  subscribers: Scalars['Int']['output'];
  subscriptionRevenue: Money;
  type: PlanType;
};


export type PlanSummarySubscriptionRevenueArgs = {
  currency: Scalars['Currency']['input'];
};

export enum PlanType {
  Basic = 'BASIC',
  Bundle = 'BUNDLE',
  Lifetime = 'LIFETIME',
  Pro = 'PRO'
}

export type PlanUpsell = {
  __typename?: 'PlanUpsell';
  annualCallout?: Maybe<Scalars['String']['output']>;
  annualTitle?: Maybe<Scalars['String']['output']>;
  callout?: Maybe<Scalars['String']['output']>;
  membershipCompareAt?: Maybe<Money>;
  registrationCompareAt?: Maybe<Money>;
};

export type PlansConnection = {
  __typename?: 'PlansConnection';
  edges: Array<PlanEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type PlansInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PlanStatus>;
  type?: InputMaybe<PlanType>;
};

export enum Platform {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Web = 'WEB'
}

export type PlatformDataPoint = {
  __typename?: 'PlatformDataPoint';
  label: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  values: Array<PlatformValue>;
};

export type PlatformSummary = {
  __typename?: 'PlatformSummary';
  change?: Maybe<PercentChange>;
  label: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  platform: Scalars['String']['output'];
  total: Money;
};

export type PlatformValue = {
  __typename?: 'PlatformValue';
  label: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  value: Money;
};

export type Pricing = {
  __typename?: 'Pricing';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  frequency?: Maybe<Frequency>;
};

export type PricingTier = {
  __typename?: 'PricingTier';
  copyrights?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  pricing?: Maybe<PlanPricing>;
};

export type PurchaseReportCreditsError = {
  __typename?: 'PurchaseReportCreditsError';
  code: PurchaseReportCreditsErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PurchaseReportCreditsErrorCode {
  PaymentFailed = 'PAYMENT_FAILED',
  ProductNotFound = 'PRODUCT_NOT_FOUND'
}

export type PurchaseReportCreditsInput = {
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
};

export type PurchaseReportCreditsPayload = {
  __typename?: 'PurchaseReportCreditsPayload';
  error?: Maybe<PurchaseReportCreditsError>;
  requiresAction?: Maybe<RequiresAction>;
};

export type Query = {
  __typename?: 'Query';
  activeSessions: ActiveSessions;
  availablePlans: AvailablePlans;
  crossBorderOverTime: CrossBorderOverTime;
  estimateRegistrationCost?: Maybe<EstimateRegistrationCost>;
  exchange?: Maybe<Exchange>;
  file?: Maybe<File>;
  files: FilesConnection;
  filesByCategory: Array<FileCategoryCount>;
  filesOverTime: FilesOverTime;
  folder?: Maybe<Folder>;
  folderByPath?: Maybe<Folder>;
  govLeaderboard: Array<GovLeaderboardEntry>;
  infringement: Infringement;
  infringements: InfringementConnection;
  me: User;
  openChargebackCount: Scalars['Int']['output'];
  origin?: Maybe<Origin>;
  origins: Array<Origin>;
  paymentStatusBreakdown: Array<PaymentStatusBreakdown>;
  ping: Scalars['String']['output'];
  plan?: Maybe<PlanSummary>;
  planGroups: Array<PlanGroup>;
  plans: PlansConnection;
  report?: Maybe<Report>;
  reportProducts: Array<ReportProduct>;
  reports: ReportConnection;
  revenueByCurrency: Array<CurrencyRevenue>;
  revenueByPlatformOverTime: RevenueByPlatformOverTime;
  revenueOverTime: RevenueOverTimeResult;
  statements: StatementsConnection;
  totalFilesOverTime: FilesOverTime;
  totalSubscriptions: Scalars['Int']['output'];
  totalUsersOverTime: UsersOverTime;
  upcomingRevenue: RevenueOverTimeResult;
  user?: Maybe<User>;
  userFolderByPath?: Maybe<Folder>;
  users: UsersConnection;
  usersOverTime: UsersOverTime;
};


export type QueryAvailablePlansArgs = {
  input: AvailablePlansInput;
};


export type QueryCrossBorderOverTimeArgs = {
  input: CrossBorderOverTimeInput;
};


export type QueryEstimateRegistrationCostArgs = {
  input: EstimateRegistrationCostInput;
};


export type QueryExchangeArgs = {
  input: ExchangeInput;
};


export type QueryFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFilesArgs = {
  input: FilesInput;
};


export type QueryFilesByCategoryArgs = {
  input: FilesByCategoryInput;
};


export type QueryFilesOverTimeArgs = {
  input: FilesOverTimeInput;
};


export type QueryFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFolderByPathArgs = {
  path: Scalars['String']['input'];
};


export type QueryGovLeaderboardArgs = {
  input: GovLeaderboardInput;
};


export type QueryInfringementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInfringementsArgs = {
  input?: InputMaybe<InfringementsInput>;
};


export type QueryOpenChargebackCountArgs = {
  origin: Scalars['ID']['input'];
};


export type QueryOriginArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentStatusBreakdownArgs = {
  input: PaymentStatusBreakdownInput;
};


export type QueryPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlanGroupsArgs = {
  origin: Scalars['String']['input'];
};


export type QueryPlansArgs = {
  input?: InputMaybe<PlansInput>;
};


export type QueryReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportsArgs = {
  input?: InputMaybe<ReportsInput>;
};


export type QueryRevenueByCurrencyArgs = {
  origin: Scalars['ID']['input'];
};


export type QueryRevenueByPlatformOverTimeArgs = {
  input: RevenueByPlatformOverTimeInput;
};


export type QueryRevenueOverTimeArgs = {
  input: RevenueOverTimeInput;
};


export type QueryStatementsArgs = {
  input: StatementsInput;
};


export type QueryTotalFilesOverTimeArgs = {
  input: TotalFilesOverTimeInput;
};


export type QueryTotalUsersOverTimeArgs = {
  input: TotalUsersOverTimeInput;
};


export type QueryUpcomingRevenueArgs = {
  input: UpcomingRevenueInput;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserFolderByPathArgs = {
  path: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  input: UsersInput;
};


export type QueryUsersOverTimeArgs = {
  input: UsersOverTimeInput;
};

export type RefundUserError = {
  __typename?: 'RefundUserError';
  code: RefundUserErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum RefundUserErrorCode {
  InvalidStatus = 'INVALID_STATUS',
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR'
}

export type RefundUserInput = {
  amount: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  invoiceId: Scalars['ID']['input'];
};

export type RefundUserPayload = {
  __typename?: 'RefundUserPayload';
  error?: Maybe<RefundUserError>;
  invoiceId?: Maybe<Scalars['ID']['output']>;
  refundId?: Maybe<Scalars['String']['output']>;
};

export type RegistrationCost = {
  __typename?: 'RegistrationCost';
  breakdown: Array<RegistrationCostItem>;
  description: Scalars['String']['output'];
  origin: Origin;
  total: Money;
};

export type RegistrationCostItem = {
  __typename?: 'RegistrationCostItem';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  total: Money;
};

export type RemoveAuthorInput = {
  fileId: Scalars['ID']['input'];
  invite: InviteInput;
};

export type RemoveAuthorsPayload = {
  __typename?: 'RemoveAuthorsPayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveCoOwnerInput = {
  fileId: Scalars['ID']['input'];
  invite: InviteInput;
};

export type RemoveCoOwnerPayload = {
  __typename?: 'RemoveCoOwnerPayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveReportViewerInput = {
  invite: InviteInput;
  reportId: Scalars['ID']['input'];
};

export type RemoveReportViewerPayload = {
  __typename?: 'RemoveReportViewerPayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveTeamMemberInput = {
  originId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type RemoveTeamMemberPayload = {
  __typename?: 'RemoveTeamMemberPayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveViewerInput = {
  fileId: Scalars['ID']['input'];
  invite: InviteInput;
};

export type RemoveViewersPayload = {
  __typename?: 'RemoveViewersPayload';
  success: Scalars['Boolean']['output'];
};

export type RenameFolderError = {
  __typename?: 'RenameFolderError';
  code: RenameFolderErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum RenameFolderErrorCode {
  InUse = 'IN_USE'
}

export type RenameFolderInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type RenameFolderPayload = {
  __typename?: 'RenameFolderPayload';
  error?: Maybe<RenameFolderError>;
  folder?: Maybe<Folder>;
};

export type Report = {
  __typename?: 'Report';
  copyright: File;
  feedback?: Maybe<FeedbackRating>;
  id: Scalars['ID']['output'];
  infringingFile: InfringingFile;
  level: ScoreLevel;
  matches: Matches;
  role: ReportRole;
  score: Scalars['Float']['output'];
  settings: ReportSettings;
  status: ReportStatus;
  summary: Scalars['String']['output'];
  timeline?: Maybe<TimelineGroup>;
  timestamp: Scalars['Timestamp']['output'];
  viewers: ReportViewersConnection;
};


export type ReportViewersArgs = {
  input: ReportViewersInput;
};

export type ReportConnection = {
  __typename?: 'ReportConnection';
  edges: Array<ReportEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type ReportEdge = {
  __typename?: 'ReportEdge';
  cursor: Scalars['String']['output'];
  node: Report;
};

export type ReportFile = File | InfringingFile;

export type ReportProduct = {
  __typename?: 'ReportProduct';
  credits: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: Pricing;
};

export enum ReportRole {
  Owner = 'OWNER',
  Public = 'PUBLIC',
  Viewer = 'VIEWER'
}

export type ReportSettings = {
  __typename?: 'ReportSettings';
  isPrivate: Scalars['Boolean']['output'];
};

export enum ReportStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export type ReportViewer = EmailInvite | Organization | User;

export type ReportViewerEdge = {
  __typename?: 'ReportViewerEdge';
  cursor: Scalars['String']['output'];
  node: ReportViewer;
  role: ReportRole;
};

export type ReportViewersConnection = {
  __typename?: 'ReportViewersConnection';
  edges: Array<ReportViewerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ReportViewersInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<CollaboratorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type RequiresAction = {
  __typename?: 'RequiresAction';
  clientSecret: Scalars['String']['output'];
};

export type RevenueByPlatformOverTime = {
  __typename?: 'RevenueByPlatformOverTime';
  platforms: Array<PlatformSummary>;
  previousSeries?: Maybe<Array<PlatformDataPoint>>;
  series: Array<PlatformDataPoint>;
};

export type RevenueByPlatformOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  revenueType: RevenueType;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueCategory = {
  __typename?: 'RevenueCategory';
  change?: Maybe<PercentChange>;
  name: Scalars['String']['output'];
  total: Money;
  type: RevenueSource;
};

export type RevenueCategoryTotal = {
  __typename?: 'RevenueCategoryTotal';
  amount: Money;
  type: RevenueSource;
};

export type RevenueComparison = {
  __typename?: 'RevenueComparison';
  change: PercentChange;
  total: Money;
};

export type RevenueDataPoint = {
  __typename?: 'RevenueDataPoint';
  label: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  value: Money;
};

export type RevenueOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Whose revenue: 'Dacr', 'gov:rio', etc. */
  origin: Scalars['ID']['input'];
  revenueType: RevenueType;
  /** Scope to transactions billed through this origin (e.g., Dacr's cut from gov:rio) */
  sourceOrigin?: InputMaybe<Scalars['ID']['input']>;
  /** Filter to specific revenue sources. Omit for all. */
  sources?: InputMaybe<Array<RevenueSource>>;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueOverTimeResult = {
  __typename?: 'RevenueOverTimeResult';
  /** Time series broken down by source (for stacked area charts) */
  breakdownSeries: Array<StackedDataPoint>;
  /** Revenue broken down by source */
  categories: Array<RevenueCategory>;
  /** Comparison period (when compareTo is set) */
  comparison?: Maybe<RevenueComparison>;
  previousBreakdownSeries?: Maybe<Array<StackedDataPoint>>;
  previousSeries?: Maybe<Array<RevenueDataPoint>>;
  /** Aggregate time series */
  series: Array<RevenueDataPoint>;
  /** Period total */
  total: Money;
};

export enum RevenueSource {
  CrossBorder = 'CROSS_BORDER',
  Custom = 'CUSTOM',
  Recognition = 'RECOGNITION',
  Registration = 'REGISTRATION',
  Report = 'REPORT',
  Subscription = 'SUBSCRIPTION'
}

export enum RevenueType {
  Gross = 'GROSS',
  Net = 'NET'
}

export enum ScoreLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type Session = {
  __typename?: 'Session';
  client?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  device?: Maybe<SessionDevice>;
  id: Scalars['ID']['output'];
  location?: Maybe<SessionLocation>;
};

export type SessionDevice = {
  __typename?: 'SessionDevice';
  browser?: Maybe<Scalars['String']['output']>;
  browserVersion?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type SessionLocation = {
  __typename?: 'SessionLocation';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type SheetMusic = {
  __typename?: 'SheetMusic';
  preview: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StackedDataPoint = {
  __typename?: 'StackedDataPoint';
  label: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  values: Array<CategoryValue>;
};

export type Statement = {
  __typename?: 'Statement';
  amount: Money;
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  origin: Origin;
  status: StatementStatus;
};

export type StatementEdge = {
  __typename?: 'StatementEdge';
  cursor: Scalars['String']['output'];
  node: Statement;
};

export enum StatementStatus {
  OnHold = 'ON_HOLD',
  Paid = 'PAID',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  UnderReview = 'UNDER_REVIEW'
}

export type StatementsConnection = {
  __typename?: 'StatementsConnection';
  edges: Array<StatementEdge>;
  pageInfo: PageInfo;
};

export type StatementsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  origin: Scalars['ID']['input'];
};

export type Stem = {
  __typename?: 'Stem';
  name: Scalars['String']['output'];
  sheetMusic?: Maybe<SheetMusic>;
  url: Scalars['String']['output'];
};

export type Stems = {
  __typename?: 'Stems';
  amplitudeUrl: Scalars['String']['output'];
  breakdown: Array<Stem>;
};

export type StreamAsset = FileAsset & {
  __typename?: 'StreamAsset';
  previewImageUrl: Scalars['String']['output'];
  streamUrl?: Maybe<Scalars['String']['output']>;
};

export type SubscribeInput = {
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
};

export type SubscribePayload = {
  __typename?: 'SubscribePayload';
  requiresAction?: Maybe<RequiresAction>;
  subscription?: Maybe<SubscriptionPlan>;
};

export type SubscriberDataPoint = {
  __typename?: 'SubscriberDataPoint';
  cancelled: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  new: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type SubscriptionAlert = {
  __typename?: 'SubscriptionAlert';
  content: I18N;
  type: SubscriptionAlertType;
};

export enum SubscriptionAlertType {
  Cancelled = 'CANCELLED',
  Chargeback = 'CHARGEBACK',
  Expired = 'EXPIRED',
  IncreaseLimit = 'INCREASE_LIMIT',
  Overdue = 'OVERDUE',
  RequiresAction = 'REQUIRES_ACTION',
  Upgrade = 'UPGRADE'
}

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  alert?: Maybe<SubscriptionAlert>;
  billingCycle: Frequency;
  cancelledAt?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['ID']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  periodEnd: Scalars['Timestamp']['output'];
  periodStart: Scalars['Timestamp']['output'];
  plan: Plan;
  pricing: PricingTier;
  status: SubscriptionStatus;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Overdue = 'OVERDUE'
}

export type TeamMember = {
  __typename?: 'TeamMember';
  email?: Maybe<Scalars['String']['output']>;
  permissions: Array<TeamPermission>;
  role: TeamRole;
  status: TeamMemberStatus;
  user?: Maybe<User>;
};

export enum TeamMemberStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED'
}

export enum TeamPermission {
  DashboardFinancials = 'DASHBOARD_FINANCIALS',
  DashboardRegistrations = 'DASHBOARD_REGISTRATIONS',
  DashboardUsers = 'DASHBOARD_USERS',
  FilesView = 'FILES_VIEW',
  StatementsView = 'STATEMENTS_VIEW',
  TeamManage = 'TEAM_MANAGE',
  TeamView = 'TEAM_VIEW',
  UsersFinancials = 'USERS_FINANCIALS',
  UsersView = 'USERS_VIEW'
}

export enum TeamRole {
  Administrator = 'ADMINISTRATOR',
  Analyst = 'ANALYST',
  Custom = 'CUSTOM',
  Support = 'SUPPORT'
}

export type TextMatch = Match & {
  __typename?: 'TextMatch';
  coords: Array<Coords>;
  file: ReportFile;
  id: Scalars['ID']['output'];
  level?: Maybe<ScoreLevel>;
  location: Scalars['String']['output'];
  markers: Array<Maybe<Marker>>;
  score?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  urls: Array<DocumentUrl>;
};

export type TextWithTimestamp = {
  __typename?: 'TextWithTimestamp';
  preview: Array<TextWithTimestampPreview>;
  url: Scalars['String']['output'];
};

export type TextWithTimestampPreview = {
  __typename?: 'TextWithTimestampPreview';
  text: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export enum TimeGrouping {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type Timeline = {
  __typename?: 'Timeline';
  audioUrl: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  frames?: Maybe<Array<Scalars['String']['output']>>;
  transcript?: Maybe<Array<Scalars['String']['output']>>;
};

export type TimelineGroup = {
  __typename?: 'TimelineGroup';
  copyright: Timeline;
  infringingFile: Timeline;
};

export type Timezone = {
  __typename?: 'Timezone';
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TimezoneInput = {
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Tip = {
  __typename?: 'Tip';
  name: TipName;
  status: TipStatus;
};

export enum TipName {
  FirstCopyright = 'FIRST_COPYRIGHT',
  Invite = 'INVITE',
  Welcome = 'WELCOME'
}

export enum TipStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Inactive = 'INACTIVE'
}

export type TotalFilesOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type TotalUsersOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type Track = {
  __typename?: 'Track';
  attributes: Array<Attribute>;
  stems: Stems;
  summary: Scalars['String']['output'];
  transcript: TextWithTimestamp;
  url: Scalars['String']['output'];
};

export type Transcript = {
  __typename?: 'Transcript';
  highlight: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type TranscriptMatch = Match & {
  __typename?: 'TranscriptMatch';
  end: Scalars['Float']['output'];
  file: ReportFile;
  id: Scalars['ID']['output'];
  level?: Maybe<ScoreLevel>;
  location: Scalars['String']['output'];
  markers: Array<Maybe<Marker>>;
  score?: Maybe<Scalars['Float']['output']>;
  start: Scalars['Float']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transcript: Array<Maybe<Transcript>>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UpcomingRevenueInput = {
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  revenueType: RevenueType;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCopyrightOwnerError = {
  __typename?: 'UpdateCopyrightOwnerError';
  code: UpdateCopyrightOwnerErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateCopyrightOwnerErrorCode {
  CopyrightOwnerNotFound = 'COPYRIGHT_OWNER_NOT_FOUND',
  InvalidInput = 'INVALID_INPUT'
}

export type UpdateCopyrightOwnerInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateCopyrightOwnerPayload = {
  __typename?: 'UpdateCopyrightOwnerPayload';
  copyrightOwner?: Maybe<CopyrightOwner>;
  error?: Maybe<UpdateCopyrightOwnerError>;
};

export type UpdateEmailError = {
  __typename?: 'UpdateEmailError';
  code: UpdateEmailErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateEmailErrorCode {
  EmailTaken = 'EMAIL_TAKEN',
  InvalidEmailFormat = 'INVALID_EMAIL_FORMAT'
}

export type UpdateEmailInput = {
  email: Scalars['String']['input'];
};

export type UpdateEmailPayload = {
  __typename?: 'UpdateEmailPayload';
  error?: Maybe<UpdateEmailError>;
  user?: Maybe<User>;
};

export type UpdateFileSettingsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFileSettingsPayload = {
  __typename?: 'UpdateFileSettingsPayload';
  file: File;
};

export type UpdateNoteInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateNotePayload = {
  __typename?: 'UpdateNotePayload';
  note: Note;
};

export type UpdateOriginBankError = {
  __typename?: 'UpdateOriginBankError';
  code: UpdateOriginBankErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateOriginBankErrorCode {
  OriginNotFound = 'ORIGIN_NOT_FOUND'
}

export type UpdateOriginBankInput = {
  accountNumber: Scalars['String']['input'];
  bankName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  originId: Scalars['ID']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  recipientName: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  swiftBic: Scalars['String']['input'];
};

export type UpdateOriginBankPayload = {
  __typename?: 'UpdateOriginBankPayload';
  error?: Maybe<UpdateOriginBankError>;
  origin?: Maybe<Origin>;
};

export type UpdateOriginError = {
  __typename?: 'UpdateOriginError';
  code: UpdateOriginErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateOriginErrorCode {
  OriginNotFound = 'ORIGIN_NOT_FOUND'
}

export type UpdateOriginInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originId: Scalars['ID']['input'];
  supportedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  useCurrency?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOriginPayload = {
  __typename?: 'UpdateOriginPayload';
  error?: Maybe<UpdateOriginError>;
  origin?: Maybe<Origin>;
};

export type UpdateOriginPortalError = {
  __typename?: 'UpdateOriginPortalError';
  code: UpdateOriginPortalErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateOriginPortalErrorCode {
  OriginNotFound = 'ORIGIN_NOT_FOUND'
}

export type UpdateOriginPortalFaqInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type UpdateOriginPortalInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  calloutLinkText?: InputMaybe<Scalars['String']['input']>;
  calloutLinkUrl?: InputMaybe<Scalars['String']['input']>;
  calloutText?: InputMaybe<Scalars['String']['input']>;
  faqs?: InputMaybe<Array<UpdateOriginPortalFaqInput>>;
  originId: Scalars['ID']['input'];
  shareDescription?: InputMaybe<Scalars['String']['input']>;
  shareTitle?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOriginPortalPayload = {
  __typename?: 'UpdateOriginPortalPayload';
  error?: Maybe<UpdateOriginPortalError>;
  origin?: Maybe<Origin>;
};

export type UpdatePaymentMethodPayload = {
  __typename?: 'UpdatePaymentMethodPayload';
  requiresAction?: Maybe<RequiresAction>;
  subscription?: Maybe<SubscriptionPlan>;
};

export type UpdatePlanCardInput = {
  callout?: InputMaybe<Scalars['String']['input']>;
  copyrightPriceQualifier?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<Scalars['Boolean']['input']>;
  includes?: InputMaybe<Array<UpdatePlanIncludeInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform: Platform;
  priceOrder?: InputMaybe<Scalars['String']['input']>;
  pricingTiers: Array<UpdatePricingTierInput>;
  productId: Scalars['ID']['input'];
  subscriptionPriceQualifier?: InputMaybe<Scalars['String']['input']>;
  upsell?: InputMaybe<UpdatePlanUpsellInput>;
};

export type UpdatePlanError = {
  __typename?: 'UpdatePlanError';
  code: UpdatePlanErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdatePlanErrorCode {
  NotFound = 'NOT_FOUND',
  Unauthorized = 'UNAUTHORIZED',
  ValidationError = 'VALIDATION_ERROR'
}

export type UpdatePlanIncludeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<UpdatePlanIncludeLinkInput>;
  separator?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
};

export type UpdatePlanIncludeLinkInput = {
  text: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type UpdatePlanInput = {
  cards?: InputMaybe<Array<UpdatePlanCardInput>>;
  enabledPlatforms?: InputMaybe<Array<Platform>>;
  name?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
  status?: InputMaybe<PlanStatus>;
};

export type UpdatePlanPayload = {
  __typename?: 'UpdatePlanPayload';
  error?: Maybe<UpdatePlanError>;
  plan?: Maybe<PlanSummary>;
};

export type UpdatePlanUpsellInput = {
  annualCallout?: InputMaybe<Scalars['String']['input']>;
  annualTitle?: InputMaybe<Scalars['String']['input']>;
  callout?: InputMaybe<Scalars['String']['input']>;
  membershipCompareAt?: InputMaybe<Scalars['String']['input']>;
  registrationCompareAt?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePriceAmountInput = {
  currency?: InputMaybe<Scalars['Currency']['input']>;
  decimalDigits?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

export type UpdatePricingTierInput = {
  copyright?: InputMaybe<UpdatePriceAmountInput>;
  copyrights?: InputMaybe<Scalars['Int']['input']>;
  frequency: Frequency;
  id?: InputMaybe<Scalars['ID']['input']>;
  subscription: UpdatePriceAmountInput;
};

export type UpdateProfileError = {
  __typename?: 'UpdateProfileError';
  code: UpdateProfileErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateProfileErrorCode {
  InvalidFirstNameFormat = 'INVALID_FIRST_NAME_FORMAT',
  InvalidLastNameFormat = 'INVALID_LAST_NAME_FORMAT',
  InvalidUsernameFormat = 'INVALID_USERNAME_FORMAT',
  UsernameTaken = 'USERNAME_TAKEN'
}

export type UpdateProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProfilePayload = {
  __typename?: 'UpdateProfilePayload';
  error?: Maybe<UpdateProfileError>;
  user?: Maybe<User>;
};

export type UpdateReportSettingsInput = {
  id: Scalars['ID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateReportSettingsPayload = {
  __typename?: 'UpdateReportSettingsPayload';
  report?: Maybe<Report>;
};

export type UpdateSettingsError = {
  __typename?: 'UpdateSettingsError';
  code: UpdateSettingsErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateSettingsErrorCode {
  InvalidTimezone = 'INVALID_TIMEZONE'
}

export type UpdateSettingsInput = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  filePrivacy?: InputMaybe<FilePrivacy>;
  timezone?: InputMaybe<TimezoneInput>;
};

export type UpdateSettingsPayload = {
  __typename?: 'UpdateSettingsPayload';
  error?: Maybe<UpdateSettingsError>;
  user?: Maybe<User>;
};

export type UpdateSubscriptionError = {
  __typename?: 'UpdateSubscriptionError';
  code: UpdateSubscriptionErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateSubscriptionErrorCode {
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR'
}

export type UpdateSubscriptionInput = {
  chargeImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type UpdateSubscriptionPayload = {
  __typename?: 'UpdateSubscriptionPayload';
  error?: Maybe<UpdateSubscriptionError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateTeamMemberError = {
  __typename?: 'UpdateTeamMemberError';
  code: UpdateTeamMemberErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateTeamMemberErrorCode {
  MemberNotFound = 'MEMBER_NOT_FOUND'
}

export type UpdateTeamMemberInput = {
  originId: Scalars['ID']['input'];
  permissions?: InputMaybe<Array<TeamPermission>>;
  role: TeamRole;
  userId: Scalars['ID']['input'];
};

export type UpdateTeamMemberPayload = {
  __typename?: 'UpdateTeamMemberPayload';
  error?: Maybe<UpdateTeamMemberError>;
  member?: Maybe<TeamMember>;
};

export type UpdateViewerPermissionsInput = {
  fileId: Scalars['ID']['input'];
  updates: Array<ViewerPermissionUpdateInput>;
};

export type UpdateViewerPermissionsPayload = {
  __typename?: 'UpdateViewerPermissionsPayload';
  file?: Maybe<File>;
};

export type UploadError = {
  __typename?: 'UploadError';
  code: UploadErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UploadErrorCode {
  SizeTooLarge = 'SIZE_TOO_LARGE'
}

export type UploadInfo = {
  __typename?: 'UploadInfo';
  headers: Scalars['Json']['output'];
  url: Scalars['String']['output'];
};

export type UploadInfringingFileError = {
  __typename?: 'UploadInfringingFileError';
  code: UploadInfringingFileErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UploadInfringingFileErrorCode {
  CopyrightNotFound = 'COPYRIGHT_NOT_FOUND',
  LimitExceeded = 'LIMIT_EXCEEDED'
}

export type UploadInfringingFileInput = {
  copyrightId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
};

export type UploadInfringingFilePayload = {
  __typename?: 'UploadInfringingFilePayload';
  error?: Maybe<UploadInfringingFileError>;
  headers?: Maybe<Scalars['Json']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UploadInput = {
  copyrightOwnerID: Scalars['ID']['input'];
  files: Array<FileMetadataInput>;
  folderId: Scalars['ID']['input'];
};

export type UploadPayload = {
  __typename?: 'UploadPayload';
  error?: Maybe<UploadError>;
  uploads: Array<UploadInfo>;
};

export type User = {
  __typename?: 'User';
  archivedFiles: ArchivedFileConnection;
  avatar: Image;
  bio?: Maybe<Scalars['String']['output']>;
  copyrightOwners: Array<CopyrightOwner>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  filesByCategory: Array<FileCategoryCount>;
  filesOverTime: FilesOverTime;
  id: Scalars['ID']['output'];
  invoices: InvoiceConnection;
  latestSession?: Maybe<Session>;
  name: Scalars['String']['output'];
  notes: NoteConnection;
  notifications: NotificationConnection;
  onboarding: OnboardingStatus;
  origin: Origin;
  permissions: Array<Permission>;
  revenue: UserRevenue;
  revenueOverTime: RevenueOverTimeResult;
  settings: UserSettings;
  status: UserStatus;
  storageUsed: Scalars['String']['output'];
  subscription: SubscriptionPlan;
  tips: Array<Tip>;
  title?: Maybe<Scalars['String']['output']>;
  totalFiles: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};


export type UserArchivedFilesArgs = {
  input: ArchiveFilesInput;
};


export type UserFilesByCategoryArgs = {
  origin: Scalars['ID']['input'];
};


export type UserFilesOverTimeArgs = {
  input: UserFilesOverTimeInput;
};


export type UserInvoicesArgs = {
  input: InvoicesInput;
};


export type UserLatestSessionArgs = {
  client?: InputMaybe<Scalars['String']['input']>;
};


export type UserNotesArgs = {
  input: UserNotesInput;
};


export type UserNotificationsArgs = {
  input: NotificationsInput;
};


export type UserRevenueArgs = {
  input: UserRevenueInput;
};


export type UserRevenueOverTimeArgs = {
  input: UserRevenueOverTimeInput;
};


export type UserStorageUsedArgs = {
  origin: Scalars['ID']['input'];
};


export type UserTotalFilesArgs = {
  origin: Scalars['ID']['input'];
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
  revenue: UserRevenue;
  totalFiles: Scalars['Int']['output'];
};


export type UserEdgeRevenueArgs = {
  currency: Scalars['Currency']['input'];
};

export type UserFilesOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  origin: Scalars['String']['input'];
};

export type UserRevenue = {
  __typename?: 'UserRevenue';
  breakdown: Array<RevenueCategoryTotal>;
  total: Money;
};

export type UserRevenueInput = {
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  revenueType: RevenueType;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UserRevenueOverTimeInput = {
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  revenueType: RevenueType;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  dateFormat: Scalars['String']['output'];
  filePrivacy: FilePrivacy;
  timezone?: Maybe<Timezone>;
};

export type UserSort = {
  direction: SortDirection;
  field: UserSortField;
};

export enum UserSortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  Registrations = 'REGISTRATIONS',
  TaxRevenue = 'TAX_REVENUE'
}

export enum UserStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Deleted = 'DELETED'
}

export type UsersComparison = {
  __typename?: 'UsersComparison';
  change: PercentChange;
  total: Scalars['Int']['output'];
};

export type UsersConnection = {
  __typename?: 'UsersConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UsersDataPoint = {
  __typename?: 'UsersDataPoint';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type UsersInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  origin: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<UserSort>;
};

export type UsersOverTime = {
  __typename?: 'UsersOverTime';
  comparison?: Maybe<UsersComparison>;
  previousSeries?: Maybe<Array<UsersDataPoint>>;
  series: Array<UsersDataPoint>;
  total: Scalars['Int']['output'];
};

export type UsersOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyIdentityInput = {
  type: IdentityVerificationType;
};

export type VerifyIdentityPayload = {
  __typename?: 'VerifyIdentityPayload';
  clientSecret?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type VideoAnalysis = Analysis & {
  __typename?: 'VideoAnalysis';
  attributes: Array<Attribute>;
  duration: Scalars['Float']['output'];
  frames: Array<Scalars['String']['output']>;
  markers: Array<Maybe<Marker>>;
  summary: Scalars['String']['output'];
  tracks: Array<Track>;
  transcript: TextWithTimestamp;
};

export type VideoMatch = Match & {
  __typename?: 'VideoMatch';
  end: Scalars['Float']['output'];
  file: ReportFile;
  frames: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<ScoreLevel>;
  location: Scalars['String']['output'];
  markers: Array<Maybe<Marker>>;
  score?: Maybe<Scalars['Float']['output']>;
  start: Scalars['Float']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Viewer = EmailInvite | ViewerEntity;

export type ViewerEdge = {
  __typename?: 'ViewerEdge';
  cursor: Scalars['String']['output'];
  node: Viewer;
};

export type ViewerEntity = {
  __typename?: 'ViewerEntity';
  entity: Entity;
  permissions: Array<FilePermission>;
  role: FileRole;
};

export type ViewerPermissionUpdateInput = {
  canDownload: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type ViewersConnection = {
  __typename?: 'ViewersConnection';
  edges: Array<ViewerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ViewersInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type VoidInvoiceError = {
  __typename?: 'VoidInvoiceError';
  code: VoidInvoiceErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum VoidInvoiceErrorCode {
  InvalidStatus = 'INVALID_STATUS',
  NotFound = 'NOT_FOUND'
}

export type VoidInvoiceInput = {
  invoiceId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type VoidInvoicePayload = {
  __typename?: 'VoidInvoicePayload';
  error?: Maybe<VoidInvoiceError>;
  invoiceId?: Maybe<Scalars['ID']['output']>;
};

export type OriginsQueryVariables = Exact<{ [key: string]: never; }>;


export type OriginsQuery = { __typename?: 'Query', origins: Array<{ __typename?: 'Origin', id: string, name: string, currency: string, flag: { __typename?: 'Image', url: string }, logo: { __typename?: 'Logo', white: { __typename?: 'Image', url: string }, black: { __typename?: 'Image', url: string } } }> };

export type VerifyIdentityMutationVariables = Exact<{
  input: VerifyIdentityInput;
}>;


export type VerifyIdentityMutation = { __typename?: 'Mutation', verifyIdentity: { __typename?: 'VerifyIdentityPayload', status: string, clientSecret?: string | null, sessionId?: string | null, message?: string | null, verifiedAt?: any | null } };

export type CopyrightFileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CopyrightFileQuery = { __typename?: 'Query', file?: { __typename?: 'File', id: string, name: string, description?: string | null, type: FileType, role: FileRole, permissions: Array<FilePermission>, asset?:
      | { __typename?: 'DocumentAsset', totalPages?: number | null, documentUrl?: string | null, previewImageUrl: string }
      | { __typename?: 'ImageAsset', previewImageUrl: string }
      | { __typename?: 'StreamAsset', streamUrl?: string | null, previewImageUrl: string }
     | null, metadata: { __typename?: 'FileMetadata', originalFilename: string, size: string }, settings: { __typename?: 'FileSettings', isPrivate: boolean }, copyright: { __typename?: 'FileCopyright', id?: string | null, status: CopyrightStatus, registrations: Array<{ __typename?: 'FileRegistration', certificateUrl?: string | null, timestamp?: any | null, origin: { __typename?: 'Origin', id: string, name: string, logo: { __typename?: 'Logo', black: { __typename?: 'Image', url: string } } } }> }, owner:
      | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
      | { __typename?: 'User', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
    , registrant: { __typename?: 'User', id: string, name: string }, authors: { __typename?: 'AuthorsConnection', totalCount: number, edges: Array<{ __typename?: 'AuthorEdge', node:
          | { __typename?: 'EmailInvite', email: string }
          | { __typename?: 'EntityWithRole', entity:
              | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
              | { __typename?: 'User', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
             }
         }> }, coOwners: { __typename?: 'CoOwnersConnection', totalCount: number, edges: Array<{ __typename?: 'CoOwnerEdge', node:
          | { __typename?: 'EmailInvite', email: string }
          | { __typename?: 'EntityWithRole', entity:
              | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
              | { __typename?: 'User', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
             }
         }> }, viewers: { __typename?: 'ViewersConnection', totalCount: number }, analysis?:
      | { __typename?: 'AudioAnalysis', summary: string, transcript: { __typename?: 'TextWithTimestamp', url: string, preview: Array<{ __typename?: 'TextWithTimestampPreview', text: string, timestamp: string }> }, tracks: Array<{ __typename?: 'Track', summary: string, url: string, attributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, transcript: { __typename?: 'TextWithTimestamp', url: string, preview: Array<{ __typename?: 'TextWithTimestampPreview', text: string, timestamp: string }> }, stems: { __typename?: 'Stems', amplitudeUrl: string, breakdown: Array<{ __typename?: 'Stem', name: string, url: string, sheetMusic?: { __typename?: 'SheetMusic', url: string, preview: string } | null }> } }>, attributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null> }
      | { __typename?: 'GenericAnalysis', summary: string, attributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null> }
      | { __typename?: 'VideoAnalysis', frames: Array<string>, summary: string, transcript: { __typename?: 'TextWithTimestamp', url: string, preview: Array<{ __typename?: 'TextWithTimestampPreview', text: string, timestamp: string }> }, tracks: Array<{ __typename?: 'Track', summary: string, url: string, attributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, transcript: { __typename?: 'TextWithTimestamp', url: string, preview: Array<{ __typename?: 'TextWithTimestampPreview', text: string, timestamp: string }> }, stems: { __typename?: 'Stems', amplitudeUrl: string, breakdown: Array<{ __typename?: 'Stem', name: string, url: string, sheetMusic?: { __typename?: 'SheetMusic', url: string, preview: string } | null }> } }>, attributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null> }
     | null, notifications: Array<{ __typename?: 'Notification', id: string, type: NotificationType, content: { __typename?: 'I18N', key: string }, actions: Array<{ __typename?: 'NotificationAction', type: NotificationActionType, buttonType: ButtonType, label: { __typename?: 'I18N', key: string } }>, details?:
        | { __typename?: 'CopyrightNotificationDetails' }
        | { __typename?: 'InviteNotificationDetails', from: { __typename?: 'User', id: string, name: string } }
       | null } | null> } | null };

export type FolderByPathQueryVariables = Exact<{
  path: Scalars['String']['input'];
  sort?: InputMaybe<ItemSort>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FolderByPathQuery = { __typename?: 'Query', folderByPath?: { __typename?: 'Folder', id: string, name: string, path: string, createdAt: any, totalFiles: number, items: { __typename?: 'ItemsConnection', totalFiles: number, edges: Array<{ __typename?: 'ItemEdge', cursor: string, node:
          | { __typename?: 'File', id: string, name: string, type: FileType, description?: string | null, role: FileRole, permissions: Array<FilePermission>, copyright: { __typename?: 'FileCopyright', id?: string | null, status: CopyrightStatus, registrations: Array<{ __typename?: 'FileRegistration', certificateUrl?: string | null, timestamp?: any | null, origin: { __typename?: 'Origin', id: string, name: string } }> }, metadata: { __typename?: 'FileMetadata', originalFilename: string, size: string }, asset?:
              | { __typename?: 'DocumentAsset', previewImageUrl: string }
              | { __typename?: 'ImageAsset', previewImageUrl: string }
              | { __typename?: 'StreamAsset', previewImageUrl: string }
             | null, settings: { __typename?: 'FileSettings', isPrivate: boolean }, owner:
              | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
              | { __typename?: 'User', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
            , coOwners: { __typename?: 'CoOwnersConnection', totalCount: number, edges: Array<{ __typename?: 'CoOwnerEdge', node:
                  | { __typename?: 'EmailInvite' }
                  | { __typename?: 'EntityWithRole', role: FileRole, entity:
                      | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
                      | { __typename?: 'User', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
                     }
                 }> }, authors: { __typename?: 'AuthorsConnection', totalCount: number, edges: Array<{ __typename?: 'AuthorEdge', node:
                  | { __typename?: 'EmailInvite' }
                  | { __typename?: 'EntityWithRole', role: FileRole, entity:
                      | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
                      | { __typename?: 'User', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
                     }
                 }> }, viewers: { __typename?: 'ViewersConnection', totalCount: number } }
          | { __typename?: 'Folder', id: string, name: string, path: string, createdAt: any, totalFiles: number }
         }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null };

export type AudioMatchFieldsFragment = { __typename?: 'AudioMatch', id: string, location: string, summary?: string | null, level?: ScoreLevel | null, matchingUrl: string, amplitudeUrl: string, start: number, end: number, duration: number, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null>, stem: { __typename?: 'Stem', name: string, url: string } } & { ' $fragmentName'?: 'AudioMatchFieldsFragment' };

export type ImageMatchFieldsFragment = { __typename?: 'ImageMatch', id: string, location: string, summary?: string | null, url: string, level?: ScoreLevel | null, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null> } & { ' $fragmentName'?: 'ImageMatchFieldsFragment' };

export type MatchBreakdownFragment = { __typename?: 'MatchCategoryBreakdown', copyright:
    | (
      { __typename?: 'AudioMatch', id: string, location: string, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File', id: string, name: string, type: FileType, asset?:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           | null, metadata: { __typename?: 'FileMetadata', originalFilename: string }, copyright: { __typename?: 'FileCopyright', id?: string | null } }
        | { __typename?: 'InfringingFile' }
       }
      & { ' $fragmentRefs'?: { 'AudioMatchFieldsFragment': AudioMatchFieldsFragment } }
    )
    | (
      { __typename?: 'ImageMatch', id: string, location: string, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File', id: string, name: string, type: FileType, asset?:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           | null, metadata: { __typename?: 'FileMetadata', originalFilename: string }, copyright: { __typename?: 'FileCopyright', id?: string | null } }
        | { __typename?: 'InfringingFile' }
       }
      & { ' $fragmentRefs'?: { 'ImageMatchFieldsFragment': ImageMatchFieldsFragment } }
    )
    | (
      { __typename?: 'TextMatch', id: string, location: string, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File', id: string, name: string, type: FileType, asset?:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           | null, metadata: { __typename?: 'FileMetadata', originalFilename: string }, copyright: { __typename?: 'FileCopyright', id?: string | null } }
        | { __typename?: 'InfringingFile' }
       }
      & { ' $fragmentRefs'?: { 'TextMatchFieldsFragment': TextMatchFieldsFragment } }
    )
    | (
      { __typename?: 'TranscriptMatch', id: string, location: string, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File', id: string, name: string, type: FileType, asset?:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           | null, metadata: { __typename?: 'FileMetadata', originalFilename: string }, copyright: { __typename?: 'FileCopyright', id?: string | null } }
        | { __typename?: 'InfringingFile' }
       }
      & { ' $fragmentRefs'?: { 'TranscriptMatchFieldsFragment': TranscriptMatchFieldsFragment } }
    )
    | (
      { __typename?: 'VideoMatch', id: string, location: string, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File', id: string, name: string, type: FileType, asset?:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           | null, metadata: { __typename?: 'FileMetadata', originalFilename: string }, copyright: { __typename?: 'FileCopyright', id?: string | null } }
        | { __typename?: 'InfringingFile' }
       }
      & { ' $fragmentRefs'?: { 'VideoMatchFieldsFragment': VideoMatchFieldsFragment } }
    )
  , infringingFile:
    | (
      { __typename?: 'AudioMatch', id: string, location: string, summary?: string | null, title: string, score?: number | null, level?: ScoreLevel | null, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File' }
        | { __typename?: 'InfringingFile', id: string, name: string, type: FileType, asset:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           }
       }
      & { ' $fragmentRefs'?: { 'AudioMatchFieldsFragment': AudioMatchFieldsFragment } }
    )
    | (
      { __typename?: 'ImageMatch', id: string, location: string, summary?: string | null, title: string, score?: number | null, level?: ScoreLevel | null, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File' }
        | { __typename?: 'InfringingFile', id: string, name: string, type: FileType, asset:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           }
       }
      & { ' $fragmentRefs'?: { 'ImageMatchFieldsFragment': ImageMatchFieldsFragment } }
    )
    | (
      { __typename?: 'TextMatch', id: string, location: string, summary?: string | null, title: string, score?: number | null, level?: ScoreLevel | null, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File' }
        | { __typename?: 'InfringingFile', id: string, name: string, type: FileType, asset:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           }
       }
      & { ' $fragmentRefs'?: { 'TextMatchFieldsFragment': TextMatchFieldsFragment } }
    )
    | (
      { __typename?: 'TranscriptMatch', id: string, location: string, summary?: string | null, title: string, score?: number | null, level?: ScoreLevel | null, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File' }
        | { __typename?: 'InfringingFile', id: string, name: string, type: FileType, asset:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           }
       }
      & { ' $fragmentRefs'?: { 'TranscriptMatchFieldsFragment': TranscriptMatchFieldsFragment } }
    )
    | (
      { __typename?: 'VideoMatch', id: string, location: string, summary?: string | null, title: string, score?: number | null, level?: ScoreLevel | null, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File' }
        | { __typename?: 'InfringingFile', id: string, name: string, type: FileType, asset:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           }
       }
      & { ' $fragmentRefs'?: { 'VideoMatchFieldsFragment': VideoMatchFieldsFragment } }
    )
   } & { ' $fragmentName'?: 'MatchBreakdownFragment' };

export type TextMatchFieldsFragment = { __typename?: 'TextMatch', id: string, location: string, level?: ScoreLevel | null, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null>, urls: Array<{ __typename?: 'DocumentUrl', page: number, url: string }>, coords: Array<{ __typename?: 'Coords', x1: number, x2: number, y1: number, y2: number, page: number }> } & { ' $fragmentName'?: 'TextMatchFieldsFragment' };

export type TranscriptMatchFieldsFragment = { __typename?: 'TranscriptMatch', id: string, location: string, summary?: string | null, score?: number | null, level?: ScoreLevel | null, start: number, end: number, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null>, transcript: Array<{ __typename?: 'Transcript', timestamp: string, text: string, highlight: boolean } | null> } & { ' $fragmentName'?: 'TranscriptMatchFieldsFragment' };

export type VideoMatchFieldsFragment = { __typename?: 'VideoMatch', id: string, location: string, summary?: string | null, level?: ScoreLevel | null, frames: Array<string>, start: number, end: number, markers: Array<{ __typename?: 'Marker', color: string, shine: boolean, visible?: boolean | null } | null> } & { ' $fragmentName'?: 'VideoMatchFieldsFragment' };

export type InfringementListQueryVariables = Exact<{
  input?: InputMaybe<InfringementsInput>;
}>;


export type InfringementListQuery = { __typename?: 'Query', infringements: { __typename?: 'InfringementConnection', totalFlags: number, totalReports: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'InfringementEdge', cursor: string, node: { __typename?: 'Infringement', id: string, label: InfringementLabel, timestamp: any, copyrights: Array<{ __typename?: 'File', id: string, name: string, type: FileType, asset?:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           | null }>, infringingFile: { __typename?: 'InfringingFile', id: string, name: string, type: FileType, asset:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           }, matches?: { __typename?: 'MatchSummary', score: number, level: ScoreLevel, breakdown: Array<{ __typename?: 'MatchSummaryBreakdown', level: ScoreLevel, score: number, type: MatchCategoryType }> } | null, report?: { __typename?: 'Report', id: string, status: ReportStatus } | null } }> } };

export type InfringementPreviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InfringementPreviewQuery = { __typename?: 'Query', infringements: { __typename?: 'InfringementConnection', totalReports: number }, infringement: { __typename?: 'Infringement', id: string, label: InfringementLabel, timestamp: any, copyrights: Array<{ __typename?: 'File', id: string, name: string, type: FileType, asset?:
        | { __typename?: 'DocumentAsset', previewImageUrl: string }
        | { __typename?: 'ImageAsset', previewImageUrl: string }
        | { __typename?: 'StreamAsset', previewImageUrl: string }
       | null }>, infringingFile: { __typename?: 'InfringingFile', id: string, name: string, type: FileType, asset:
        | { __typename?: 'DocumentAsset', previewImageUrl: string }
        | { __typename?: 'ImageAsset', previewImageUrl: string }
        | { __typename?: 'StreamAsset', previewImageUrl: string }
       }, matches?: { __typename?: 'MatchSummary', score: number, level: ScoreLevel, breakdown: Array<{ __typename?: 'MatchSummaryBreakdown', level: ScoreLevel, score: number, type: MatchCategoryType }> } | null } };

export type CreateReportMutationVariables = Exact<{
  input: CreateReportInput;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'CreateReportPayload', success: boolean, error?: { __typename?: 'CreateReportError', code: CreateReportErrorCode, message?: string | null } | null } };

export type ReportMatchesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReportMatchesQuery = { __typename?: 'Query', report?: { __typename?: 'Report', id: string, copyright: { __typename?: 'File', id: string, name: string, type: FileType, asset?:
        | { __typename?: 'DocumentAsset', previewImageUrl: string }
        | { __typename?: 'ImageAsset', previewImageUrl: string }
        | { __typename?: 'StreamAsset', previewImageUrl: string }
       | null, copyright: { __typename?: 'FileCopyright', id?: string | null, registrations: Array<{ __typename?: 'FileRegistration', timestamp?: any | null }> } }, infringingFile: { __typename?: 'InfringingFile', id: string, name: string, type: FileType, asset:
        | { __typename?: 'DocumentAsset', previewImageUrl: string }
        | { __typename?: 'ImageAsset', previewImageUrl: string }
        | { __typename?: 'StreamAsset', previewImageUrl: string }
       }, matches: { __typename?: 'Matches', categories: Array<{ __typename?: 'MatchCategory', type: MatchCategoryType, summary?: { __typename?: 'MatchCategorySummary', copyright: string, infringingFile: string } | null, breakdown: Array<(
          { __typename?: 'MatchCategoryBreakdown', copyright:
            | { __typename?: 'AudioMatch' }
            | { __typename?: 'ImageMatch', bbox?: Array<string> | null }
            | { __typename?: 'TextMatch' }
            | { __typename?: 'TranscriptMatch', transcriptUrl?: string | null }
            | { __typename?: 'VideoMatch' }
          , infringingFile:
            | { __typename?: 'AudioMatch' }
            | { __typename?: 'ImageMatch', bbox?: Array<string> | null }
            | { __typename?: 'TextMatch' }
            | { __typename?: 'TranscriptMatch', transcriptUrl?: string | null }
            | { __typename?: 'VideoMatch' }
           }
          & { ' $fragmentRefs'?: { 'MatchBreakdownFragment': MatchBreakdownFragment } }
        )> }> } } | null };

export type ReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReportQuery = { __typename?: 'Query', report?: { __typename?: 'Report', id: string, role: ReportRole, timestamp: any, summary: string, score: number, level: ScoreLevel, feedback?: FeedbackRating | null, copyright: { __typename?: 'File', id: string, name: string, type: FileType, metadata: { __typename?: 'FileMetadata', originalFilename: string }, asset?:
        | { __typename?: 'DocumentAsset', previewImageUrl: string }
        | { __typename?: 'ImageAsset', previewImageUrl: string }
        | { __typename?: 'StreamAsset', previewImageUrl: string }
       | null, copyright: { __typename?: 'FileCopyright', id?: string | null }, analysis?:
        | { __typename?: 'AudioAnalysis' }
        | { __typename?: 'GenericAnalysis' }
        | { __typename?: 'VideoAnalysis', duration: number }
       | null }, infringingFile: { __typename?: 'InfringingFile', id: string, name: string, type: FileType, attributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, asset:
        | { __typename?: 'DocumentAsset', totalPages?: number | null, documentUrl?: string | null, previewImageUrl: string }
        | { __typename?: 'ImageAsset', previewImageUrl: string }
        | { __typename?: 'StreamAsset', streamUrl?: string | null, previewImageUrl: string }
       }, matches: { __typename?: 'Matches', total: number, categories: Array<{ __typename?: 'MatchCategory', type: MatchCategoryType, breakdown: Array<(
          { __typename?: 'MatchCategoryBreakdown' }
          & { ' $fragmentRefs'?: { 'MatchBreakdownFragment': MatchBreakdownFragment } }
        )> }> }, timeline?: { __typename?: 'TimelineGroup', infringingFile: { __typename?: 'Timeline', transcript?: Array<string> | null, audioUrl: string, frames?: Array<string> | null, duration: number }, copyright: { __typename?: 'Timeline', transcript?: Array<string> | null, audioUrl: string, frames?: Array<string> | null, duration: number } } | null, settings: { __typename?: 'ReportSettings', isPrivate: boolean }, viewers: { __typename?: 'ReportViewersConnection', totalCount: number, edges: Array<{ __typename?: 'ReportViewerEdge', cursor: string, role: ReportRole, node:
          | { __typename?: 'EmailInvite', email: string }
          | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
              | { __typename?: 'Organization' }
              | { __typename?: 'User', id: string, name: string }
             }
          | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
         }> } } | null };

export type CreateFeedbackMutationVariables = Exact<{
  input: CreateFeedbackInput;
}>;


export type CreateFeedbackMutation = { __typename?: 'Mutation', createFeedback: { __typename?: 'CreateFeedbackPayload', success: boolean, feedbackId?: string | null } };

export type ReportProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportProductsQuery = { __typename?: 'Query', reportProducts: Array<{ __typename?: 'ReportProduct', id: string, name: string, description: string, credits: number, price: { __typename?: 'Pricing', amount: number, currencyCode: string } }> };

export type PurchaseReportCreditsMutationVariables = Exact<{
  input: PurchaseReportCreditsInput;
}>;


export type PurchaseReportCreditsMutation = { __typename?: 'Mutation', purchaseReportCredits: { __typename?: 'PurchaseReportCreditsPayload', requiresAction?: { __typename?: 'RequiresAction', clientSecret: string } | null, error?: { __typename?: 'PurchaseReportCreditsError', code: PurchaseReportCreditsErrorCode, message?: string | null } | null } };

export type SelectCopyrightFolderQueryVariables = Exact<{
  path: Scalars['String']['input'];
}>;


export type SelectCopyrightFolderQuery = { __typename?: 'Query', folderByPath?: { __typename?: 'Folder', id: string, name: string, path: string, items: { __typename?: 'ItemsConnection', edges: Array<{ __typename?: 'ItemEdge', node:
          | { __typename?: 'File', id: string, name: string, type: FileType, copyright: { __typename?: 'FileCopyright', id?: string | null, registrations: Array<{ __typename?: 'FileRegistration', timestamp?: any | null }> }, asset?:
              | { __typename?: 'DocumentAsset', previewImageUrl: string }
              | { __typename?: 'ImageAsset', previewImageUrl: string }
              | { __typename?: 'StreamAsset', previewImageUrl: string }
             | null }
          | { __typename?: 'Folder', id: string, name: string, path: string, totalFiles: number }
         }> } } | null };

export type FileViewersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FileViewersQuery = { __typename?: 'Query', file?: { __typename?: 'File', id: string, viewers: { __typename?: 'ViewersConnection', totalCount: number, edges: Array<{ __typename?: 'ViewerEdge', node:
          | { __typename?: 'EmailInvite', email: string }
          | { __typename?: 'ViewerEntity', role: FileRole, permissions: Array<FilePermission>, entity:
              | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                  | { __typename?: 'Organization' }
                  | { __typename?: 'User', id: string, name: string }
                 }
              | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
             }
         }> } } | null };

export type AddViewersMutationVariables = Exact<{
  input: AddViewersInput;
}>;


export type AddViewersMutation = { __typename?: 'Mutation', addViewers: { __typename?: 'AddViewersPayload', error?: { __typename?: 'AddCoOwnersError', code: AddCoOwnersErrorCode, message?: string | null } | null, file?: { __typename?: 'File', id: string, viewers: { __typename?: 'ViewersConnection', totalCount: number, edges: Array<{ __typename?: 'ViewerEdge', node:
            | { __typename?: 'EmailInvite', email: string }
            | { __typename?: 'ViewerEntity', role: FileRole, permissions: Array<FilePermission>, entity:
                | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                    | { __typename?: 'Organization' }
                    | { __typename?: 'User', id: string, name: string }
                   }
                | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
               }
           }> } } | null } };

export type UpdateViewerPermissionsMutationVariables = Exact<{
  input: UpdateViewerPermissionsInput;
}>;


export type UpdateViewerPermissionsMutation = { __typename?: 'Mutation', updateViewerPermissions: { __typename?: 'UpdateViewerPermissionsPayload', file?: { __typename?: 'File', id: string, viewers: { __typename?: 'ViewersConnection', totalCount: number, edges: Array<{ __typename?: 'ViewerEdge', node:
            | { __typename?: 'EmailInvite', email: string }
            | { __typename?: 'ViewerEntity', role: FileRole, permissions: Array<FilePermission>, entity:
                | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                    | { __typename?: 'Organization' }
                    | { __typename?: 'User', id: string, name: string }
                   }
                | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
               }
           }> } } | null } };

export type FileAuthorsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FileAuthorsQuery = { __typename?: 'Query', file?: { __typename?: 'File', id: string, authors: { __typename?: 'AuthorsConnection', totalCount: number, edges: Array<{ __typename?: 'AuthorEdge', node:
          | { __typename?: 'EmailInvite', email: string }
          | { __typename?: 'EntityWithRole', role: FileRole, entity:
              | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                  | { __typename?: 'Organization' }
                  | { __typename?: 'User', id: string, name: string }
                 }
              | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
             }
         }> } } | null };

export type AddAuthorsMutationVariables = Exact<{
  input: AddAuthorsInput;
}>;


export type AddAuthorsMutation = { __typename?: 'Mutation', addAuthors: { __typename?: 'AddAuthorsPayload', error?: { __typename?: 'AddCoOwnersError', code: AddCoOwnersErrorCode, message?: string | null } | null, file?: { __typename?: 'File', id: string, authors: { __typename?: 'AuthorsConnection', totalCount: number, edges: Array<{ __typename?: 'AuthorEdge', node:
            | { __typename?: 'EmailInvite', email: string }
            | { __typename?: 'EntityWithRole', role: FileRole, entity:
                | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                    | { __typename?: 'Organization' }
                    | { __typename?: 'User', id: string, name: string }
                   }
                | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
               }
           }> } } | null } };

export type FileOwnersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FileOwnersQuery = { __typename?: 'Query', file?: { __typename?: 'File', id: string, coOwners: { __typename?: 'CoOwnersConnection', totalCount: number, edges: Array<{ __typename?: 'CoOwnerEdge', node:
          | { __typename?: 'EmailInvite', email: string }
          | { __typename?: 'EntityWithRole', role: FileRole, entity:
              | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                  | { __typename?: 'Organization' }
                  | { __typename?: 'User', id: string, name: string }
                 }
              | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
             }
         }> } } | null };

export type AddCoOwnersMutationVariables = Exact<{
  input: AddCoOwnersInput;
}>;


export type AddCoOwnersMutation = { __typename?: 'Mutation', addCoOwners: { __typename?: 'AddCoOwnersPayload', error?: { __typename?: 'AddCoOwnersError', code: AddCoOwnersErrorCode, message?: string | null } | null, file?: { __typename?: 'File', id: string, coOwners: { __typename?: 'CoOwnersConnection', totalCount: number, edges: Array<{ __typename?: 'CoOwnerEdge', node:
            | { __typename?: 'EmailInvite', email: string }
            | { __typename?: 'EntityWithRole', role: FileRole, entity:
                | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                    | { __typename?: 'Organization' }
                    | { __typename?: 'User', id: string, name: string }
                   }
                | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
               }
           }> } } | null } };

export type MoveFoldersQueryVariables = Exact<{
  path: Scalars['String']['input'];
}>;


export type MoveFoldersQuery = { __typename?: 'Query', folderByPath?: { __typename?: 'Folder', id: string, name: string, path: string, items: { __typename?: 'ItemsConnection', edges: Array<{ __typename?: 'ItemEdge', node:
          | { __typename?: 'File' }
          | { __typename?: 'Folder', id: string, name: string, path: string, totalFiles: number }
         }> } } | null };

export type RemoveViewerMutationVariables = Exact<{
  input: RemoveViewerInput;
}>;


export type RemoveViewerMutation = { __typename?: 'Mutation', removeViewer: { __typename?: 'RemoveViewersPayload', success: boolean } };

export type RemoveAuthorMutationVariables = Exact<{
  input: RemoveAuthorInput;
}>;


export type RemoveAuthorMutation = { __typename?: 'Mutation', removeAuthor: { __typename?: 'RemoveAuthorsPayload', success: boolean } };

export type RemoveCoOwnerMutationVariables = Exact<{
  input: RemoveCoOwnerInput;
}>;


export type RemoveCoOwnerMutation = { __typename?: 'Mutation', removeCoOwner: { __typename?: 'RemoveCoOwnerPayload', success: boolean } };

export type UploadInfringingFileMutationVariables = Exact<{
  input: UploadInfringingFileInput;
}>;


export type UploadInfringingFileMutation = { __typename?: 'Mutation', uploadInfringingFile: { __typename?: 'UploadInfringingFilePayload', id?: string | null, url?: string | null, headers?: any | null, error?: { __typename?: 'UploadInfringingFileError', code: UploadInfringingFileErrorCode, message?: string | null } | null } };

export type AddReportViewersMutationVariables = Exact<{
  input: AddReportViewersInput;
}>;


export type AddReportViewersMutation = { __typename?: 'Mutation', addReportViewers: { __typename?: 'AddReportViewersPayload', error?: { __typename?: 'AddReportViewersError', message?: string | null } | null, report?: { __typename?: 'Report', id: string, settings: { __typename?: 'ReportSettings', isPrivate: boolean }, viewers: { __typename?: 'ReportViewersConnection', totalCount: number, edges: Array<{ __typename?: 'ReportViewerEdge', cursor: string, role: ReportRole, node:
            | { __typename?: 'EmailInvite', email: string }
            | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                | { __typename?: 'Organization' }
                | { __typename?: 'User', id: string, name: string }
               }
            | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
           }> } } | null } };

export type RemoveReportViewerMutationVariables = Exact<{
  input: RemoveReportViewerInput;
}>;


export type RemoveReportViewerMutation = { __typename?: 'Mutation', removeReportViewer: { __typename?: 'RemoveReportViewerPayload', success: boolean } };

export type UpdateReportSettingsMutationVariables = Exact<{
  input: UpdateReportSettingsInput;
}>;


export type UpdateReportSettingsMutation = { __typename?: 'Mutation', updateReportSettings: { __typename?: 'UpdateReportSettingsPayload', report?: { __typename?: 'Report', id: string, settings: { __typename?: 'ReportSettings', isPrivate: boolean } } | null } };

export type EstimateRegistrationCostQueryVariables = Exact<{
  input: EstimateRegistrationCostInput;
}>;


export type EstimateRegistrationCostQuery = { __typename?: 'Query', estimateRegistrationCost?: { __typename?: 'EstimateRegistrationCost', total: { __typename?: 'Money', amount: string, formatted: string }, breakdown: Array<{ __typename?: 'RegistrationCost', description: string, origin: { __typename?: 'Origin', id: string, name: string, flag: { __typename?: 'Image', url: string } }, total: { __typename?: 'Money', amount: string, formatted: string }, breakdown: Array<{ __typename?: 'RegistrationCostItem', id: string, name: string, total: { __typename?: 'Money', amount: string, formatted: string } }> }> } | null };

export type EstimateRegistrationCostInitialQueryVariables = Exact<{
  input: EstimateRegistrationCostInput;
}>;


export type EstimateRegistrationCostInitialQuery = { __typename?: 'Query', estimateRegistrationCost?: { __typename?: 'EstimateRegistrationCost', total: { __typename?: 'Money', amount: string, formatted: string }, breakdown: Array<{ __typename?: 'RegistrationCost', description: string, origin: { __typename?: 'Origin', id: string, name: string, flag: { __typename?: 'Image', url: string } }, total: { __typename?: 'Money', amount: string, formatted: string }, breakdown: Array<{ __typename?: 'RegistrationCostItem', id: string, name: string, total: { __typename?: 'Money', amount: string, formatted: string } }> }> } | null };

export const AudioMatchFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AudioMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"matchingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"amplitudeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<AudioMatchFieldsFragment, unknown>;
export const ImageMatchFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}}]} as unknown as DocumentNode<ImageMatchFieldsFragment, unknown>;
export const TextMatchFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TextMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x1"}},{"kind":"Field","name":{"kind":"Name","value":"x2"}},{"kind":"Field","name":{"kind":"Name","value":"y1"}},{"kind":"Field","name":{"kind":"Name","value":"y2"}},{"kind":"Field","name":{"kind":"Name","value":"page"}}]}}]}}]} as unknown as DocumentNode<TextMatchFieldsFragment, unknown>;
export const TranscriptMatchFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"highlight"}}]}}]}}]} as unknown as DocumentNode<TranscriptMatchFieldsFragment, unknown>;
export const VideoMatchFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"frames"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}}]} as unknown as DocumentNode<VideoMatchFieldsFragment, unknown>;
export const MatchBreakdownFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatchBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MatchCategoryBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AudioMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TextMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoMatchFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InfringingFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AudioMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TextMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoMatchFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AudioMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"matchingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"amplitudeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TextMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x1"}},{"kind":"Field","name":{"kind":"Name","value":"x2"}},{"kind":"Field","name":{"kind":"Name","value":"y1"}},{"kind":"Field","name":{"kind":"Name","value":"y2"}},{"kind":"Field","name":{"kind":"Name","value":"page"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"highlight"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"frames"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}}]} as unknown as DocumentNode<MatchBreakdownFragment, unknown>;
export const OriginsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Origins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"flag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"white"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"black"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OriginsQuery, OriginsQueryVariables>;
export const VerifyIdentityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyIdentity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyIdentityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyIdentity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}}]}}]}}]} as unknown as DocumentNode<VerifyIdentityMutation, VerifyIdentityMutationVariables>;
export const CopyrightFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CopyrightFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StreamAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streamUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certificateUrl"}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"black"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"3"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ACCEPTED"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coOwners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"3"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ACCEPTED"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"analysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioAnalysis"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amplitudeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"sheetMusic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"preview"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAnalysis"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frames"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amplitudeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"sheetMusic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"preview"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InviteNotificationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CopyrightFileQuery, CopyrightFileQueryVariables>;
export const FolderByPathDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FolderByPath"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folderByPath"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalFiles"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certificateUrl"}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coOwners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"3"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ACCEPTED"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"authors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"3"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ACCEPTED"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Folder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalFiles"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalFiles"}}]}}]}}]}}]} as unknown as DocumentNode<FolderByPathQuery, FolderByPathQueryVariables>;
export const InfringementListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InfringementList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InfringementsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infringements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalFlags"}},{"kind":"Field","name":{"kind":"Name","value":"totalReports"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"copyrights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InfringementListQuery, InfringementListQueryVariables>;
export const InfringementPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InfringementPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infringements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalReports"}}]}},{"kind":"Field","name":{"kind":"Name","value":"infringement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"copyrights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InfringementPreviewQuery, InfringementPreviewQueryVariables>;
export const CreateReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateReportMutation, CreateReportMutationVariables>;
export const ReportMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportMatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyright"}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatchBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"bbox"},"name":{"kind":"Name","value":"coords"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"transcriptUrl"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"bbox"},"name":{"kind":"Name","value":"coords"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"transcriptUrl"},"name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AudioMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"matchingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"amplitudeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TextMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x1"}},{"kind":"Field","name":{"kind":"Name","value":"x2"}},{"kind":"Field","name":{"kind":"Name","value":"y1"}},{"kind":"Field","name":{"kind":"Name","value":"y2"}},{"kind":"Field","name":{"kind":"Name","value":"page"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"highlight"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"frames"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatchBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MatchCategoryBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AudioMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TextMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoMatchFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InfringingFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AudioMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TextMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoMatchFields"}}]}}]}}]}}]} as unknown as DocumentNode<ReportMatchesQuery, ReportMatchesQueryVariables>;
export const ReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Report"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"analysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAnalysis"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StreamAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streamUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatchBreakdown"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frames"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frames"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ALL"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AudioMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"matchingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"amplitudeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TextMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x1"}},{"kind":"Field","name":{"kind":"Name","value":"x2"}},{"kind":"Field","name":{"kind":"Name","value":"y1"}},{"kind":"Field","name":{"kind":"Name","value":"y2"}},{"kind":"Field","name":{"kind":"Name","value":"page"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"highlight"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"frames"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatchBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MatchCategoryBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AudioMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TextMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoMatchFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InfringingFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AudioMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TextMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoMatchFields"}}]}}]}}]}}]} as unknown as DocumentNode<ReportQuery, ReportQueryVariables>;
export const CreateFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFeedbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"feedbackId"}}]}}]}}]} as unknown as DocumentNode<CreateFeedbackMutation, CreateFeedbackMutationVariables>;
export const ReportProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}}]}}]} as unknown as DocumentNode<ReportProductsQuery, ReportProductsQueryVariables>;
export const PurchaseReportCreditsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PurchaseReportCredits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseReportCreditsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseReportCredits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiresAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PurchaseReportCreditsMutation, PurchaseReportCreditsMutationVariables>;
export const SelectCopyrightFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectCopyrightFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folderByPath"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Folder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"totalFiles"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SelectCopyrightFolderQuery, SelectCopyrightFolderQueryVariables>;
export const FileViewersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FileViewers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FileViewersQuery, FileViewersQueryVariables>;
export const AddViewersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddViewers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddViewersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addViewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddViewersMutation, AddViewersMutationVariables>;
export const UpdateViewerPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateViewerPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateViewerPermissionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateViewerPermissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateViewerPermissionsMutation, UpdateViewerPermissionsMutationVariables>;
export const FileAuthorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FileAuthors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ALL"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FileAuthorsQuery, FileAuthorsQueryVariables>;
export const AddAuthorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddAuthors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddAuthorsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addAuthors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ALL"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddAuthorsMutation, AddAuthorsMutationVariables>;
export const FileOwnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FileOwners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"coOwners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ALL"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FileOwnersQuery, FileOwnersQueryVariables>;
export const AddCoOwnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddCoOwners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddCoOwnersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCoOwners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"coOwners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ALL"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddCoOwnersMutation, AddCoOwnersMutationVariables>;
export const MoveFoldersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MoveFolders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folderByPath"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"FOLDER"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Folder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"totalFiles"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MoveFoldersQuery, MoveFoldersQueryVariables>;
export const RemoveViewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveViewer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveViewerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeViewer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RemoveViewerMutation, RemoveViewerMutationVariables>;
export const RemoveAuthorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveAuthor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveAuthorInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeAuthor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RemoveAuthorMutation, RemoveAuthorMutationVariables>;
export const RemoveCoOwnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveCoOwner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveCoOwnerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCoOwner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RemoveCoOwnerMutation, RemoveCoOwnerMutationVariables>;
export const UploadInfringingFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadInfringingFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadInfringingFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadInfringingFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"headers"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UploadInfringingFileMutation, UploadInfringingFileMutationVariables>;
export const AddReportViewersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddReportViewers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddReportViewersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addReportViewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ALL"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddReportViewersMutation, AddReportViewersMutationVariables>;
export const RemoveReportViewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveReportViewer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveReportViewerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeReportViewer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RemoveReportViewerMutation, RemoveReportViewerMutationVariables>;
export const UpdateReportSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReportSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateReportSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReportSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateReportSettingsMutation, UpdateReportSettingsMutationVariables>;
export const EstimateRegistrationCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EstimateRegistrationCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimateRegistrationCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateRegistrationCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"flag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EstimateRegistrationCostQuery, EstimateRegistrationCostQueryVariables>;
export const EstimateRegistrationCostInitialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EstimateRegistrationCostInitial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimateRegistrationCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateRegistrationCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"flag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EstimateRegistrationCostInitialQuery, EstimateRegistrationCostInitialQueryVariables>;